﻿/* =============================================================================
   shopnest.js â€” ShopNest custom behaviour for the Xtra theme
   -----------------------------------------------------------------------------
   Loaded AFTER Xtra's custom.js (theme.liquid edit #001).

   RULES (see CLAUDE.md Â§4):
   - One namespace: window.ShopNest. No other globals.
   - Every init is idempotent â€” guard with a data-sn-* attr or a flag so it
     never double-binds when Shopify re-renders a section in the theme editor.
   - Re-run section logic on 'shopify:section:load'. Don't assume one-shot load.
   - Do NOT re-implement what Xtra already does (sliders = Swiper via Xtra,
     ratings = Xtra 'ratings' event, nav/sticky = Xtra custom.js). Enhance only.

   Most of the redesign is CSS. Only add JS here when behaviour is genuinely
   needed and Xtra doesn't already provide it.
   ============================================================================= */

(function () {
  'use strict';

  window.ShopNest = window.ShopNest || {};
  var SN = window.ShopNest;

  /* --- tiny helpers -------------------------------------------------------- */

  // Run fn once now (if DOM ready) and never rely on a single DOMContentLoaded.
  SN.ready = function (fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  };

  // Idempotent guard: returns false if this element was already inited for `key`.
  // Usage: if (!SN.claim(el, 'header')) return;
  SN.claim = function (el, key) {
    if (!el) return false;
    var attr = 'data-sn-' + key;
    if (el.getAttribute(attr) === '1') return false;
    el.setAttribute(attr, '1');
    return true;
  };

  /* --- section registry ---------------------------------------------------- */
  // Register a section initializer. It runs on first load AND whenever the
  // theme editor reloads a matching section. Init functions must be idempotent
  // (use SN.claim). `test` is an optional selector string; if given, init only
  // runs when the (re)loaded section contains it.

  SN._inits = [];

  SN.register = function (name, initFn, test) {
    SN._inits.push({ name: name, run: initFn, test: test });
  };

  SN._runAll = function (root) {
    for (var i = 0; i < SN._inits.length; i++) {
      var entry = SN._inits[i];
      try {
        if (entry.test && root && root.querySelector && !root.querySelector(entry.test)) {
          // section reload that doesn't contain this feature â€” skip
          if (root !== document) continue;
        }
        entry.run(root || document);
      } catch (e) {
        if (window.console) console.warn('[ShopNest] init "' + entry.name + '" failed:', e);
      }
    }
  };

  // First load â€” see the bottom of this file for why the actual SN.ready(...)
  // call is placed there instead of here.

  // Theme editor: re-init the reloaded section only
  document.addEventListener('shopify:section:load', function (e) {
    SN._runAll((e && e.target) || document);
  });


  /* =========================================================================
     SECTION INITS
     Add one SN.register(...) per section that needs JS, as the checklist
     reaches it. Keep them idempotent. Example pattern:

     SN.register('header', function (root) {
       var header = root.querySelector('#header-inner') || document.querySelector('#header-inner');
       if (!SN.claim(header, 'header')) return;
       // ... enhance here ...
     }, '#header-inner');
     ========================================================================= */

  /* --- HEADER ------------------------------------------------------ â¬œ TODO */

  /* --- GALLERY ----------------------------------------------------- â¬œ TODO */

  /* --- BUY / QUANTITY ------------------------------------------------ âœ… DONE
     .sn-qsel quantity dropdown (matches reference/prototype.html's
     .qsel/.qsel-btn/.qsel-pop/.qo system; classes renamed sn-qsel/sn-qsel-btn/
     sn-qsel-pop/sn-qo/sn-qc/sn-qv/sn-qmk per CLAUDE.md Â§2). Markup lives in
     snippets/main-product-info.liquid (core edit #016).

     Integration point: every .sn-qsel carries data-sn-target, a selector for
     the REAL <input type="number" name="quantity"> that Shopify's add-to-cart
     form actually reads. Picking an option sets that input's value and
     dispatches `change` on it â€” nothing here duplicates or replaces what
     Shopify submits, it only drives the real field.

     Inventory cap: options are built from the real input's own min/max
     attributes (already correctly set by Liquid from
     current_variant.inventory_quantity / quantity_rule.max â€” see
     shopnest.css's BUY BUTTON + QUANTITY note), never a hardcoded ceiling.
     SN_QSEL_FALLBACK_MAX is only used when the input has no max at all
     (merchant allows unlimited / backorder â€” a real "no limit", not a bug).

     Re-init hook: Xtra's variant-switch flow (custom-async.js) fully replaces
     `.f8pr-amount` with fresh server HTML on every variant change (it's in
     that function's `elementsToReplace` list) and then dispatches its own
     `semanticInput` window CustomEvent â€” the same event that drives Xtra's
     native stepper init. Listening for it here means every variant switch
     gets a fresh, freshly-bounded dropdown automatically, same as a
     shopify:section:load.

     No backdrop: originally dimmed the page while open (mirroring
     reference/prototype.html's #qbackdrop), removed after a real click test
     showed it sitting above the popup rows and swallowing clicks meant for
     them (`.f8pr-amount` needs its own `position:relative; z-index:9` for
     layering, which pins the popup's whole stacking-context subtree below
     the backdrop's). "Click outside closes" below is independent of any
     backdrop element â€” it stays.

     Popup is reparented to <body> (permanent "portal" pattern, not just
     while open): the upward-opening case hit the SAME stacking-context bug
     as the backdrop click issue, just against different neighbors (variant
     buttons etc. instead of the backdrop) â€” any ancestor between .sn-qsel
     and <body> that sets z-index (there's always at least one, `.f8pr-amount`
     itself, needed for its own layering) pins the popup below whatever else
     on the page has a higher root-level stacking rank. Reparenting means the
     popup's z-index (SN_QSEL_Z below) always competes directly at the root
     stacking context â€” no ancestor can ever trap it again, including future
     .mini instances in the sticky bar / recommendation cards. Position is
     computed in JS from the trigger's real getBoundingClientRect() (fixed
     coordinates, not CSS `top: calc(100% + Npx)` relative to a parent that
     no longer exists once reparented) and recalculated fresh every open.
     Closes on real window scroll/resize (not the popup's own internal
     scroll â€” 'scroll' doesn't bubble to window from a nested overflow
     container, so scrolling the options list itself won't close it)
     instead of continuously repositioning, which is the standard tradeoff
     for this pattern. */

  var SN_QSEL_FALLBACK_MAX = 99;
  // Above Xtra's own on-demand overlays (off-canvas nav drawer is 9999,
  // screen.css:3945) since this is the same "user just opened it" category;
  // below Xtra's true modal (999999/1000000, recommendation-modal) so a real
  // modal can still cover it if both were somehow open at once.
  var SN_QSEL_Z = 20000;

  function qselBuildOptions(pop, input) {
    var min = parseInt(input.getAttribute('min'), 10);
    if (isNaN(min)) min = 1;
    var step = parseInt(input.getAttribute('step'), 10);
    if (isNaN(step) || step < 1) step = 1;
    var maxAttr = input.getAttribute('max');
    var max = maxAttr ? parseInt(maxAttr, 10) : NaN;
    if (isNaN(max)) max = min + (SN_QSEL_FALLBACK_MAX - 1) * step;

    var current = parseInt(input.value, 10);
    if (isNaN(current) || current < min) current = min;
    if (current > max) current = max;

    var html = '';
    var checkSvg = '<svg class="sn-qmk" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12l5 5L20 6"/></svg>';
    for (var v = min; v <= max; v += step) {
      var isSel = v === current;
      html += '<button type="button" class="sn-qo' + (isSel ? ' sel' : '') +
        '" role="option" aria-selected="' + (isSel ? 'true' : 'false') +
        '" data-value="' + v + '">' + checkSvg + '<span>' + v + '</span></button>';
    }
    pop.innerHTML = html;
    input.value = current;
    return current;
  }

  function qselClose(sel) {
    sel.classList.remove('open');
    var pop = sel._snPop;
    if (pop) pop.classList.remove('open', 'up');
    var btn = sel.querySelector('.sn-qsel-btn');
    if (btn) btn.setAttribute('aria-expanded', 'false');
  }

  function qselCloseAll() {
    var open = document.querySelectorAll('.sn-qsel.open');
    for (var i = 0; i < open.length; i++) qselClose(open[i]);
  }

  function qselPositionAndOpen(sel, btn, pop) {
    qselCloseAll();
    sel.classList.add('open');
    pop.classList.add('open');
    btn.setAttribute('aria-expanded', 'true');

    var r = btn.getBoundingClientRect();

    // Horizontal: not in the original spec (only vertical .up flipping was),
    // but worth guarding now that positioning is against the full viewport
    // instead of a local parent â€” a trigger near the right edge could
    // otherwise push the popup off-screen. Mirrors the vertical .up check:
    // flip to right-aligned only if left-aligned would overflow.
    var popWidth = parseFloat(getComputedStyle(pop).width) || 168;
    if (r.left + popWidth > window.innerWidth) {
      pop.style.left = 'auto';
      pop.style.right = (window.innerWidth - r.right) + 'px';
    } else {
      pop.style.right = 'auto';
      pop.style.left = r.left + 'px';
    }

    if (sel.classList.contains('mini')) {
      // .mini contexts (sticky bar, recommendation cards) sit low on the
      // page by design â€” always open upward, no space measurement needed.
      pop.classList.add('up');
      pop.style.top = 'auto';
      pop.style.bottom = (window.innerHeight - r.top + 6) + 'px';
      return;
    }

    var maxH = parseInt(getComputedStyle(pop).maxHeight, 10) || 300;
    var need = Math.min(pop.scrollHeight, maxH) + 14;
    var below = window.innerHeight - r.bottom;
    var above = r.top;
    var openUp = below < need && above > below;

    pop.classList.toggle('up', openUp);
    if (openUp) {
      pop.style.top = 'auto';
      pop.style.bottom = (window.innerHeight - r.top + 8) + 'px';
    } else {
      pop.style.bottom = 'auto';
      pop.style.top = (r.bottom + 8) + 'px';
    }
  }

  function qselPick(sel, input, pop, optionEl) {
    var value = optionEl.getAttribute('data-value');

    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));

    // Mirror Xtra's own data-link convention (custom-async.js amountClick),
    // same as it did for the native stepper â€” #quantity and
    // #product_qty_sticky (core edit #026) point at each other. Since both
    // ends are now .sn-qsel dropdowns (not a plain input), also find the
    // OTHER instance targeting the linked input and update its own display
    // â€” otherwise the linked <input>.value was correct but that dropdown's
    // visible "N" badge would silently go stale until it was opened again
    // (its option list rebuilds from the input's live value on open, so
    // only the always-visible badge text needed this, not the option
    // list itself). Found live: picking a value in the sticky dropdown
    // correctly set #quantity's value, but #main-product's own .sn-qv
    // still showed the old number.
    var linkSel = input.getAttribute('data-link');
    if (linkSel) {
      var linked = document.querySelector(linkSel);
      if (linked) {
        linked.value = value;
        var linkedSel = document.querySelector('[data-sn-qsel][data-sn-target="' + CSS.escape(linkSel) + '"]');
        var linkedQv = linkedSel ? linkedSel.querySelector('.sn-qv') : null;
        if (linkedQv) linkedQv.textContent = value;
      }
    }

    var qv = sel.querySelector('.sn-qv');
    if (qv) qv.textContent = value;

    var opts = pop.querySelectorAll('.sn-qo');
    for (var i = 0; i < opts.length; i++) {
      var isSel = opts[i] === optionEl;
      opts[i].classList.toggle('sel', isSel);
      opts[i].setAttribute('aria-selected', isSel ? 'true' : 'false');
    }

    qselCloseAll();
  }

  /* Quantity-selector width matched to the first variant button (PDP main
     instance only â€” not the .mini contexts). Investigated before building:

     - Two variant systems exist and are mutually exclusive per product,
       confirmed live (never both on the same page): the native Shopify
       picker (#main-product .f8pr-variant-selection .check.box label) and
       a separate custom "linked variant" block for cross-linked product
       sizes (.linked-variant-btn, its own inline-styled markup, unrelated
       to the native picker). Both handled â€” whichever is present is used.
     - Both use an 8px gap between buttons (measured live). The quantity-
       selector/buy-button gap was ALSO meant to be 8px
       (--f8pr_submit_dist), but measured 24px â€” .f8pr-amount's own auto
       width was resolving to 90px against its 74px button regardless of
       what's inside it (a real, pre-existing bug, unrelated to variants â€”
       see the width/min-width note on #main-product .submit .f8pr-amount
       in shopnest.css). Fixed there; once .f8pr-amount's box width
       genuinely equals its content, matching that width to the first
       variant button is sufficient on its own to land the buy button's
       left edge on the second variant button's left edge â€” no separate
       positioning logic needed for the buy button, confirmed by
       measurement after implementing.
     - Pure CSS (subgrid / matching grid-template-columns, as asked for)
       was investigated and ruled out: subgrid needs the variant row and
       the submit row to share a common grid ancestor with nothing
       unrelated in between, but in the real markup they're siblings
       inside #main-product's block loop with OTHER merchant-reorderable
       blocks (price, stock, delivery) between them â€” wrapping just these
       two in a shared grid container would mean assuming they're
       adjacent, which breaks CLAUDE.md Â§5's block-order-agnostic
       requirement the moment a merchant reorders blocks or inserts
       another one between them. Matching independent grid-template-
       columns doesn't work either: the two rows' first columns are sized
       by genuinely different content (variant label text vs. the qsel's
       fixed "1" + chevron), so two separate auto-sized grids have no
       shared reference and won't naturally agree â€” only subgrid (or JS)
       can force that. This is a one-time width read-and-apply after
       render, not a continuously-recomputed position â€” it only reruns on
       the same discrete events already driving re-init elsewhere
       (page load, shopify:section:load, Xtra's variant-switch
       'semanticInput' event, and viewport resize since wrap state is
       viewport-width-dependent) â€” unlike the earlier popup-positioning
       code, there's no scroll-tracking or floating-overlay coordinate math
       involved, so the same fragility category doesn't apply here.
     - Exactly one variant button: matches that single button's width, buy
       button fills the remainder as normal â€” falls out of the same logic
       with no special case (min() of an array of one is that one value).
     - Wrapping: both variant systems use flex-wrap: wrap and, on narrow
       viewports with enough options, genuinely can wrap (confirmed the
       CSS allows it; not force-reproduced on this store's current catalog
       â€” no product has enough options to wrap at any tested width, but
       the code doesn't assume that stays true). Detected by comparing
       each button's own top to the first button's top; on any mismatch,
       falls back to the CSS default (74px, set directly in shopnest.css)
       rather than aligning to a row that's about to wrap unpredictably.
     - No-variant case: neither selector matches anything, so the function
       resets any previously-applied inline width and returns â€” the CSS
       default (74px, buy button flex: 1, 8px gap) is exactly what was
       already built, untouched. */
  // The real function normally already exists by the time this line runs:
  // main-product-info.liquid has a small inline <script> (core edit #019)
  // placed directly after the row's own markup, defining
  // window.ShopNest.qselMatchVariantWidth and calling it immediately â€” the
  // instant that markup is parsed, long before this deferred script has
  // even downloaded, let alone executed (see write-up in that file and in
  // SHOPNEST-CHANGES.md #019 for why: DOMContentLoaded/semanticInput were
  // both far too late for a value this file needs to apply before first
  // paint). Defining it here too, guarded, keeps this file self-sufficient
  // if that inline script is ever missing (a different template, a future
  // refactor) â€” identical logic either way, SN.qselMatchVariantWidth is the
  // one canonical function regardless of which definition wins.
  SN.qselMatchVariantWidth = SN.qselMatchVariantWidth || function () {
    var amount = document.querySelector('#main-product .f8pr-amount');
    if (!amount) return;
    var btn = amount.querySelector('.sn-qsel-btn');

    var nativeBtns = document.querySelectorAll('#main-product .f8pr-variant-selection .check.box label');
    var linkedBtns = document.querySelectorAll('#main-product .linked-variant-btn');
    var btns = nativeBtns.length ? nativeBtns : linkedBtns;

    if (!btns.length) {
      amount.style.width = '';
      if (btn) btn.style.width = '';
      return;
    }

    var firstRect = btns[0].getBoundingClientRect();
    var wrapped = false;
    for (var i = 1; i < btns.length; i++) {
      if (Math.abs(btns[i].getBoundingClientRect().top - firstRect.top) > 1) {
        wrapped = true;
        break;
      }
    }

    var width = wrapped ? '' : (firstRect.width + 'px');
    amount.style.width = width;
    if (btn) btn.style.width = width;
  };
  function qselMatchVariantWidth() { SN.qselMatchVariantWidth(); }

  SN.register('qsel', function (root) {
    qselMatchVariantWidth();

    var sels = root.querySelectorAll('[data-sn-qsel]');
    for (var i = 0; i < sels.length; i++) {
      // IIFE per instance (not `var` closures) â€” needed correctness once
      // more than one .sn-qsel exists on a page (sticky bar / recommendation
      // cards, later), so each instance's listeners stay bound to ITS OWN
      // sel/input/pop instead of whichever one the loop landed on last.
      (function (sel) {
        if (!SN.claim(sel, 'qsel')) return;

        var targetSel = sel.getAttribute('data-sn-target');
        var input = targetSel ? document.querySelector(targetSel) : null;
        if (!input) return;

        var pop = sel.querySelector('.sn-qsel-pop');
        if (!pop) return;

        // Reparent to <body> permanently (see write-up above), not just
        // while open. Dedupe on data-sn-target: Xtra's variant-switch AJAX
        // replaces the whole `.f8pr-amount` (and the fresh nested pop
        // inside it) on every variant change, so without this a leftover
        // body-level pop from the previous variant would never get cleaned
        // up.
        var dedupeKey = targetSel;
        var stale = document.querySelectorAll('.sn-qsel-pop[data-sn-for="' + CSS.escape(dedupeKey) + '"]');
        for (var s = 0; s < stale.length; s++) stale[s].remove();
        pop.setAttribute('data-sn-for', dedupeKey);
        pop.style.zIndex = SN_QSEL_Z;
        pop.classList.toggle('mini', sel.classList.contains('mini'));
        document.body.appendChild(pop);
        sel._snPop = pop;

        var current = qselBuildOptions(pop, input);
        var qv = sel.querySelector('.sn-qv');
        if (qv) qv.textContent = current;

        var btn = sel.querySelector('.sn-qsel-btn');
        btn.addEventListener('click', function () {
          if (sel.classList.contains('open')) {
            qselClose(sel);
          } else {
            qselPositionAndOpen(sel, btn, pop);
          }
        });

        pop.addEventListener('click', function (e) {
          var opt = e.target.closest('.sn-qo');
          if (opt) qselPick(sel, input, pop, opt);
        });
      })(sels[i]);
    }
  }, '[data-sn-qsel]');

  // Re-run after Xtra's variant-switch AJAX replaces .f8pr-amount with fresh
  // server HTML (see write-up above) â€” 'semanticInput' is the window
  // CustomEvent Xtra dispatches right after that swap (and on first load).
  window.addEventListener('semanticInput', function () {
    SN._runAll(document);
  });

  document.addEventListener('click', function (e) {
    // .sn-qsel-pop is reparented to <body>, so a click on a row is no
    // longer inside [data-sn-qsel] â€” check both.
    if (!e.target.closest('[data-sn-qsel]') && !e.target.closest('.sn-qsel-pop')) {
      qselCloseAll();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') qselCloseAll();
  });

  // Fixed-position popups don't track the trigger as the page scrolls/
  // resizes; closing (rather than repositioning on every scroll tick) is
  // the standard tradeoff for this pattern. window-level 'scroll' only
  // fires for the page itself, not the popup's own internal overflow-y
  // scrolling (that doesn't bubble here), so scrolling a long options list
  // won't close it.
  window.addEventListener('scroll', qselCloseAll, { passive: true });
  window.addEventListener('resize', qselCloseAll, { passive: true });

  // Re-check the variant-width match on resize â€” wrap state (single row vs.
  // wrapped) is viewport-width-dependent, unlike everything else above.
  // Debounced: a width read-and-apply is cheap, but no need to run it on
  // every resize tick while the user is actively dragging a window edge.
  var qselResizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(qselResizeTimer);
    qselResizeTimer = setTimeout(qselMatchVariantWidth, 150);
  }, { passive: true });

  // Prevents a flash on load: the buy/quantity row is hidden by default in
  // shopnest.css (visibility: hidden â€” not display: none, which would cause
  // a SECOND layout jump on reveal, since the row already occupies its
  // final space the whole time, it just isn't painted) until this reveals
  // it. In the normal case the inline bootstrap script (core edit #019,
  // main-product-info.liquid) already reveals within tens of ms of that
  // markup being parsed â€” this function/timeout exist purely as backstops
  // for whatever's left uncovered by that.
  function qselRevealRow() {
    var submit = document.querySelector('#main-product .submit');
    if (submit) submit.classList.add('sn-revealed');
  }

  // Safety net only â€” the inline bootstrap script already reveals almost
  // immediately in the normal case (see above), so this should essentially
  // never be the thing that actually fires it. Short on purpose: 350ms is
  // generous room for THIS script's own (slower, defer-gated) path to
  // finish if the inline bootstrap is ever missing, without leaving a
  // genuinely broken page hidden for anywhere near as long as before.
  // Independent CSS-only animation fallback in shopnest.css (shorter too,
  // now) covers the case where no JS runs at all.
  setTimeout(qselRevealRow, 350);

  window.addEventListener('semanticInput', qselRevealRow);

  /* --- BUY BUTTON: "added" flash ------------------------------------- âœ… DONE
     Matches reference/prototype.html's flashAdded() exactly: checkmark +
     "Toegevoegd", auto-reverts after 1200ms, busy-flag guards a
     double-click/double-submit from re-triggering mid-flash (same
     dataset-flag mechanism as the prototype, not a new invention).

     Difference from the prototype, deliberate: the prototype calls
     flashAdded() OPTIMISTICALLY, synchronously on click, because it's a
     static mockup with no real network request behind it. Here there IS a
     real add-to-cart request (Xtra's own ajaxCart, custom-async.js),
     which can fail (stock, network) â€” flashing a false "success" checkmark
     regardless would be wrong, so this waits for Xtra's own success
     signal instead of firing on click.

     Investigated first (no dispatched CustomEvent for cart-add success to
     hook into): Xtra's ajaxCart.formOverride() intercepts the form's
     'submit', preventDefault()s it, and on a successful response calls the
     shared setProcessed(form) helper (custom-async.js) â€” adds `.processed`
     to the form (auto-removed after ITS OWN unrelated 3000ms, no relation
     to our 1200ms). On error, `.processing` is removed and `.processed` is
     NOT added. So watching for `.processed` actually being added is a
     reliable, non-invasive success signal â€” doesn't require adding a
     second 'submit' listener or touching Xtra's own handler at all. */

  // iconOnly (core edit #099): product-card buy buttons are icon-only â€”
  // no room/precedent for the "Toegevoegd" text this was originally built
  // for (#081/#085/#092 all keep that button compact, icon-only by design)
  // â€” same checkmark, same class/timer mechanics, just the bare icon.
  function buyButtonFlashAdded(btn, iconOnly) {
    if (!btn || btn.dataset.snBusy) return;
    btn.dataset.snBusy = '1';

    var original = btn.innerHTML;
    btn.classList.add('sn-added');
    btn.innerHTML =
      '<svg class="sn-added-check" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12l5 5L20 6"/></svg>' +
      (iconOnly ? '' : 'Toegevoegd');

    setTimeout(function () {
      btn.innerHTML = original;
      btn.classList.remove('sn-added');
      delete btn.dataset.snBusy;
    }, 1200);
  }

  SN.register('buyButtonFlash', function (root) {
    var form = (root.querySelector && root.querySelector('#main-product form.f8pr-buy-button')) ||
      document.querySelector('#main-product form.f8pr-buy-button');
    if (!SN.claim(form, 'buyFlash')) return;

    // Flashes every buy button tied to this form, not just the one inside
    // #main-product â€” the sticky bar's button (sections/sticky-add-to-cart
    // .liquid, core edit #026) isn't a DOM descendant of this form at all;
    // it submits it via `form="<this form's id>"` instead, so it has to be
    // found separately (an actual descendant query would never see it).
    //
    // form.getAttribute('id'), not form.id: this product form has a hidden
    // <input name="id"> (Shopify's standard variant-id field), and per the
    // HTML spec a form's named form-control access shadows its own `id`
    // IDL property when a descendant control shares that name â€” form.id
    // returns that INPUT element here, not the id string. Confirmed live
    // (form.id logged as an HTMLInputElement, not a string), which made
    // the external-button lookup below always match zero elements even
    // though the button's own `form="..."` attribute was correct the
    // whole time. getAttribute('id') isn't a named-property lookup, so it
    // isn't affected by this and always returns the real string.
    var observer = new MutationObserver(function () {
      if (!form.classList.contains('processed')) return;
      var buttons = form.querySelectorAll('.overlay-buy_button');
      for (var i = 0; i < buttons.length; i++) buyButtonFlashAdded(buttons[i]);
      var formIdAttr = form.getAttribute('id');
      if (formIdAttr) {
        var external = document.querySelectorAll('[form="' + CSS.escape(formIdAttr) + '"].overlay-buy_button');
        for (var j = 0; j < external.length; j++) buyButtonFlashAdded(external[j]);
      }
    });
    observer.observe(form, { attributes: true, attributeFilter: ['class'] });
  }, '#main-product form.f8pr-buy-button');

  /* --- PDP GALLERY: sale badge doesn't update on variant switch ------ âœ… DONE
     Reported: switching variants (e.g. 236ml -> 473ml) correctly updates
     the price and its own inline discount pill (`.price-off`, core edit
     #012, in main-product-info.liquid) â€” but the separate sale badge
     overlaid on the main gallery image (`.s1lb .overlay-sale`,
     snippets/product-labels.liquid) stays frozen on whatever
     `product.selected_or_first_available_variant` resolved to at the
     initial page load.

     Root cause, found by reading custom-async.js's variant-change
     handler (the `window.addEventListener('productVariants', ...)`
     listener): on every variant change it fetches the freshly-rendered
     section HTML and unconditionally swaps a fixed list of elements
     including `.f8pr-price` (why the price and `.price-off` update
     correctly) â€” but the gallery (`.l4pr-container`, where `.s1lb`/
     `.overlay-sale` actually lives) is only swapped when
     `shouldUpdateVariantGallery` is true, which requires the merchant
     setting "show image on variant selection" to be on. Confirmed in
     `templates/product.json` this store has it off, so the gallery
     (and its badge) is never touched by that swap at all.

     Not fixed by enabling that setting, and not fixed by editing
     custom-async.js directly: that's Xtra's own core file (last resort
     per CLAUDE.md Â§3), and either approach would also start swapping the
     gallery PHOTOS on variant switch â€” a real behaviour change the
     merchant has deliberately left off, well beyond "make the badge
     update, don't change anything else." Instead, this watches for the
     same swap that already updates the price (a MutationObserver on
     `#main-product`, since `.f8pr-price` and its sibling blocks are all
     replaced in that same synchronous batch) and mirrors `.price-off`'s
     already-correct discount text into the gallery badge.

     Deliberately reads `.price-off`'s rendered text rather than
     independently re-deriving the percentage from raw price/compare_at_
     price numbers: neither is exposed anywhere on the page as a
     machine-readable value â€” `compare_at_price` only ever appears
     already run through Shopify's `money` filter (`.price-was`), and
     re-parsing a *localized currency string* back into a number in JS
     is exactly the kind of fragile-across-locales/currencies logic
     worth avoiding when a correct, already-computed value already
     exists two DOM nodes away. `.price-off` **is** that value â€” the
     exact same Liquid math (price vs compare_at_price) this project
     already trusts for the price display itself â€” so mirroring it is a
     single source of truth, not a second calculation that could quietly
     drift from the first. */
  SN.register('galleryBadgeSync', function (root) {
    var form = (root.querySelector && root.querySelector('#main-product form.f8pr-buy-button')) ||
      document.querySelector('#main-product form.f8pr-buy-button');
    if (!SN.claim(form, 'galleryBadgeSync')) return;

    function syncBadge() {
      var labelWrap = document.querySelector('#main-product .l4pr .s1lb');
      if (!labelWrap) return;
      var priceOff = document.querySelector('#main-product .f8pr-price .price-off');
      var saleSpan = labelWrap.querySelector('.overlay-sale');

      if (priceOff) {
        if (!saleSpan) {
          saleSpan = document.createElement('span');
          saleSpan.className = 'overlay-sale';
          labelWrap.insertBefore(saleSpan, labelWrap.firstChild);
        }
        saleSpan.textContent = priceOff.textContent.trim();
      } else if (saleSpan) {
        saleSpan.remove();
      }
    }

    var container = document.querySelector('#main-product');
    if (!container) return;

    // Debounced: the elementsToReplace swap in custom-async.js touches
    // several sibling blocks (.f8pr-price, .f8pr-stock, .f8pr-variant-
    // selection, ...) in quick succession, each a separate mutation â€”
    // coalesce into one resync rather than run it several times per
    // variant switch. syncBadge() is idempotent either way (re-reading
    // .price-off and re-applying the same value is a no-op), so this is
    // purely an efficiency nicety, not a correctness requirement.
    var debounceTimer;
    var observer = new MutationObserver(function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(syncBadge, 50);
    });
    observer.observe(container, { childList: true, subtree: true });
  }, '#main-product form.f8pr-buy-button');

  /* --- PRODUCT CARDS: "added" flash (core edit #099) ------------------ âœ… DONE
     Reported: pressing a card's cart button showed Xtra's own native
     orange checkmark (unstyled by us) instead of the same green flash the
     PDP/sticky buttons already have. Root cause: buyButtonFlash above is
     hardcoded to the PDP's one `#main-product` form â€” cards were never
     wired in at all, so `.sn-added` never gets added to a card's button
     and the native async-validation.css checkmark (::after, unstyled,
     orange background left untouched) is all that ever shows.

     Same buyButtonFlashAdded() helper, reused as-is (iconOnly: true â€” see
     that function's own comment) â€” the only real difference from the PDP
     case is there are MANY card forms per page/section instead of one, so
     this loops root.querySelectorAll and claims each form individually,
     same pattern as the qsel init above. No "external button via form=
     attribute" lookup needed here (unlike the sticky bar) â€” a card's
     button always lives inside its own form, never elsewhere in the DOM.

     Only .overlay-buy_button/.overlay-preorder are watched, not
     .overlay-unavailable-buy-button: confirmed live in product-item.liquid
     that button renders type="button" (current_variant.available == false
     branch) â€” inert, never submits, so its form can never actually reach
     .processed from clicking it. Matches this file's own established
     principle (see the #081 comment on .sn-qsel's omitted "nobackdrop"
     modifier): don't wire up a state that can't occur. */
  SN.register('cardBuyButtonFlash', function (root) {
    var forms = root.querySelectorAll('.legacy-product-card .f8pr.form-card');
    for (var i = 0; i < forms.length; i++) {
      (function (form) {
        if (!SN.claim(form, 'cardBuyFlash')) return;
        var observer = new MutationObserver(function () {
          if (!form.classList.contains('processed')) return;
          var buttons = form.querySelectorAll('.overlay-buy_button, .overlay-preorder');
          for (var j = 0; j < buttons.length; j++) buyButtonFlashAdded(buttons[j], true);
        });
        observer.observe(form, { attributes: true, attributeFilter: ['class'] });
      })(forms[i]);
    }
  }, '.legacy-product-card .f8pr.form-card');

  /* --- PRODUCT CARDS: kill secondary/hover image on touch devices ---- âœ… DONE
     Belt-and-suspenders companion to the CSS fix in shopnest.css (core
     edit #102, the "@media (hover: none)" block near the card image
     rules) â€” reported STILL broken on a real iPhone (both Safari and
     Chrome â€” on iOS both sit on top of WebKit, Apple requires it, so
     seeing it in "two browsers" doesn't rule out a WebKit-specific cause,
     it's consistent with one) even after that CSS fix was verified
     correct through extensive Chromium-based testing: direct landscape
     load, a simulated portraitâ†’landscape resize/orientationchange, a
     real dispatched touch-swipe gesture across the carousel, a full
     portraitâ†’landscapeâ†’swipeâ†’portrait round trip, the collection page
     grid as well as the PDP carousels â€” all clean, zero anomalies â€” and
     confirmed live against the actual production CDN asset, not just the
     dev preview. Headless Chromium is Blink-based; it cannot reproduce
     whatever WebKit-specific behavior is actually triggering this on a
     real device (iOS's own well-documented sticky-:hover-on-tap quirk is
     the leading theory â€” see the CSS fix's own comment for the full
     mechanism â€” but it can't be verified against the one engine that
     actually matters here).

     Rather than keep tuning a CSS specificity battle I can't test against
     the real failure case, this sidesteps the cascade entirely: an INLINE
     style set via JS (`style.setProperty(..., 'important')`) outranks ANY
     external stylesheet rule regardless of selector specificity, by
     CSS's own cascade-origin rules â€” immune to whatever combination of
     native Xtra rules (there were three, found the hard way â€” see the
     CSS fix's comment) or WebKit-specific quirks might still be defeating
     a purely selector-based fix. Gated on the same `(hover: none)`
     condition as the CSS fix; unlike most of this file's viewport-
     reactive code, no resize/orientationchange listener is needed here â€”
     hover capability doesn't change when a device rotates, only the
     viewport dimensions do. */
  SN.register('killSecondImgHoverOnTouch', function (root) {
    if (!window.matchMedia('(hover: none)').matches) return;
    var cards = root.querySelectorAll('.second-img-hover');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (!SN.claim(card, 'killSecondImg')) continue;
      var pics = card.querySelectorAll('figure picture');
      if (pics.length < 2) continue;
      var primaryIndex = card.classList.contains('second-img-first') ? pics.length - 1 : 0;
      for (var j = 0; j < pics.length; j++) {
        pics[j].style.setProperty('display', j === primaryIndex ? 'block' : 'none', 'important');
      }
    }
  }, '.second-img-hover');

  /* --- PRODUCT CARDS: move sale badge outside figure (desktop) ------- âœ… DONE
     Core edit #124. Requested: badge should sit flush with the CARD's own
     outer corner (accounting for the card shell's 14px padding, core edit
     #118), not just the image's corner (#121/#122/#123 only ever reached
     the image's edge). Real constraint, checked before writing this:
     `.legacy-product-card figure` has `overflow: hidden` (core edit #104,
     a genuine cross-device image-bleed fix, deliberately unscoped â€”
     confirmed via that entry's own write-up it must stay unscoped to work
     at the width it was built for) â€” no CSS-only offset on `.s1lb` can
     escape that clip while it remains a DOM descendant of figure. Rather
     than touch #104's rule (risks reintroducing the bug it fixed) or edit
     the Liquid template (a core-file change, last resort per CLAUDE.md
     Â§3), this mirrors the exact pattern `pdpInfoTabs` already established
     for the same category of problem: move the element via JS, gated to
     desktop only, leaving the Liquid-rendered DOM (and therefore mobile,
     which never runs this) completely untouched.
     `.legacy-product-card > .s1lb.label` (shopnest.css) gives the badge
     `position: absolute` once it's a direct child of the card â€” the card
     `<li>` already has native `position: relative` (`.l4cl li`, screen.css),
     so no ancestor CSS needs touching either. Bounded-hide (same pattern
     as #112/#114, `.sn-card-badge-ready`) prevents a visible jump between
     the badge's pre-move (inside figure, 8px) and post-move (outside
     figure, card-relative) positions on initial paint. */
  SN.register('cardBadgeCorner', function (root) {
    if (!window.matchMedia('(min-width: 750px)').matches) return;
    var cards = root.querySelectorAll('.legacy-product-card');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var s1lb = card.querySelector('figure > .s1lb.label');
      if (s1lb && SN.claim(s1lb, 'cardBadgeCorner')) {
        card.insertBefore(s1lb, card.firstChild);
      }
      /* #273 — the card wishlist heart (core edit #272, rendered inside
         figure by product-item.liquid) has the SAME problem this module
         exists for, discovered live: figure's clip (#104's overflow:hidden
         under 750, #129's clip-path inset(-9999px 0) at 750+) cuts the
         heart's right half the moment it overhangs figure's side to reach
         the CARD's corner — a straight vertical amputation at figure.right,
         confirmed by DSF6 crop. Same cure as the badge: make it a direct
         child of the card li, whose position:relative it then positions
         against. App-safe by the app's own code (read, not assumed): click
         handling is document-level delegation via closest(), and initCard's
         duplicate guard is container.querySelector — both only need the
         button to remain a DESCENDANT of the card, which it does. */
      var heart = card.querySelector('figure > button.product-card-wishlist-btn');
      if (heart && SN.claim(heart, 'cardHeartCorner')) {
        card.insertBefore(heart, card.firstChild);
      }
    }
    document.documentElement.classList.add('sn-card-badge-ready');
  }, '.legacy-product-card');

  /* --- HEADER: cart badge fallback when the cart drawer is off ------- âœ… DONE
     Reported: header #cart-count doesn't update after a successful add â€”
     only a full page reload shows the new total.

     Root cause, confirmed live (not assumed): NOT a staleness/caching
     issue â€” the merchant genuinely has the Overlay group's "Cart drawer"
     section turned off (sections/overlay-group.json, side-cart:
     `"disabled": true`, set via the theme editor), so `#cart`
     (sections/side-cart.liquid) never renders into the DOM at all, ever,
     for the whole pageview. Xtra's own ajaxCart.handleAddToCartResponse
     (custom-async.js) only calls into updateCartPanel(response, true, ...)
     â€” the path that eventually calls updateCartCount() and writes the new
     total into #cart-count â€” inside `if (document.getElementById('cart')
     != null)`. With the drawer off that condition is false, so it takes
     the `else` branch instead, which does nothing when sideCartContainer
     is also null. No error, nothing broken-looking â€” the count just never
     moves until a fresh page load re-renders #cart-count from Liquid.
     This is a real gap in Xtra's own code for the "no drawer" theme
     configuration, not something introduced here â€” it doesn't belong in
     custom-async.js per CLAUDE.md Â§1, so it's a small standalone fallback
     here instead, only active when there's genuinely no drawer to do
     Xtra's native update.

     Same success signal as buyButtonFlash above (.processed newly added
     to the form) â€” reused rather than adding a second submit listener.

     Widened after a second report: adding from a PRODUCT CARD left the badge
     stale too. Measured live â€” card add moved the server cart 0 â†’ 1 while the
     badge stayed "0"; collection card 1 â†’ 2, badge stayed "1". The signal was
     never the problem: `handleAddToCartResponse` (custom-async.js:7338) is the
     single funnel for every ajax add and sets `.processed` on whichever form
     was submitted, cards included (confirmed true on the card form 2s after
     the click). This watcher was simply scoped to one element â€” the PDP's
     `#main-product form.f8pr-buy-button` â€” so no card was ever observed.

     Now one document-level observer covers every `/cart/add` form. That also
     picks up forms that did not exist at load: cards render up to 48 forms per
     page across carousels and quick-add panels, and the quickshop overlay
     inserts its form only when opened, so per-form observers bound at init
     would miss exactly the flows being reported. */

  function refreshCartCountFallback() {
    var els = document.querySelectorAll('#cart-count, #cart-count--m');
    if (!els.length) return;
    var root = (typeof getShopifyRouteRoot === 'function') ? getShopifyRouteRoot() : '/';
    fetch(root + 'cart.js', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        for (var i = 0; i < els.length; i++) els[i].textContent = data.item_count;
      })
      .catch(function () { /* best-effort only â€” a fresh reload still works as before */ });
  }

  SN.register('cartCountFallback', function () {
    // bound to the document, not to a section, so guard on the document itself
    // rather than SN.claim â€” shopify:section:load re-runs must not stack
    // observers, and there is no per-section element to claim here.
    if (document.documentElement.snCartCountBound) return;
    document.documentElement.snCartCountBound = true;

    // Edge-detect the processed transition (not just "is processed right
    // now") so a form that stays .processed across several unrelated class
    // mutations only triggers one fetch per add, not one per mutation.
    // State lives on each form, since one observer now serves all of them.
    var observer = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var form = records[i].target;
        if (!form || form.tagName !== 'FORM') continue;
        if ((form.getAttribute('action') || '').indexOf('/cart/add') === -1) continue;

        var isProcessed = form.classList.contains('processed');
        if (isProcessed && !form.snWasProcessed && !document.getElementById('cart')) {
          refreshCartCountFallback();
        }
        form.snWasProcessed = isProcessed;
      }
    });
    observer.observe(document.documentElement, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
  });

  /* --- STICKY ADD TO CART: reveal trigger ----------------------------- âœ… DONE
     Reported: the sticky bar was appearing/disappearing based on the
     variant picker's visibility instead of the main buy button's.

     Xtra's own reveal mechanism (custom-async.js: an IntersectionObserver
     via getProductScrollTarget(form), toggling html.product-scrolled,
     which assets/async-product-scrolled.css keys off) is SUPPOSED to
     already watch just the small form wrapping the quantity/buy-button
     row, not the variant picker â€” checked live and couldn't reproduce a
     wrong target there directly (its own getBoundingClientRect matched
     the buy-button row every time, not the variant picker). That
     mechanism can't be edited here regardless, per CLAUDE.md Â§1, and â€” a
     real limitation of this checking, not a claim it's fine â€” doesn't
     reliably respond to synthetic scrollTo() in headless testing, so it
     couldn't be fully re-verified against a real scroll gesture either.

     Rather than keep chasing a mechanism that can't be edited or fully
     re-tested, this adds an independent, directly-verifiable trigger:
     watches the actual #main-product buy button â€” exactly what was asked
     for â€” and drives the sticky bar's visibility via a dedicated
     html.sn-sticky-show class with !important CSS (STICKY ADD TO CART
     slot, shopnest.css) so it's the deciding factor regardless of
     whatever Xtra's own product-scrolled/m6pn-open classes are doing.
     Doesn't fight or disable Xtra's own observer â€” just makes it moot for
     this specific visual outcome.

     Deliberately does NOT try to reuse Xtra's own header-height-aware
     threshold (--header_outer_height, matched against
     boundingClientRect.bottom via rootMargin â€” genuinely tried this
     first). That variable defaults to a 3000px sentinel in screen.css
     (`:root { --header_outer_height: 3000px }`) â€” Xtra's own convention
     for "not calculated yet" â€” and is only corrected by custom-async.js's
     setHeaderOuterHeight() after the page's FIRST scroll or resize event.
     Read once at setup, before any scrolling has happened, it's still
     3000px â€” confirmed live (getComputedStyle read exactly "3000px"),
     which made rootMargin collapse the observed root to nothing and
     boundingClientRect.bottom (an actual ~878px) permanently satisfy
     `<= 3000`, so the bar showed unconditionally from page load, not on
     any real scroll trigger. Simplified instead to a plain, self-
     contained check against the raw viewport (bottom <= 0 â€” the button
     has scrolled fully above the top) â€” no dependency on a value that
     depends on Xtra's own timing to become correct. This means the bar
     can show a header's-height sooner or later than Xtra's own bar would
     have (a sticky header may still cover the last sliver of the button
     when this triggers) â€” a minor difference, not the thing that was
     reported broken, and safer than depending on a value with a proven
     sharp edge.

     Still respects .m6pn-open (mobile nav drawer open) via the CSS
     selector, same as Xtra's own rule â€” doesn't show the bar over an open
     nav drawer just because the buy button also happens to be
     off-screen. */
  var stickyRevealObserver = null;
  SN.register('stickyReveal', function () {
    var buyBtn = document.querySelector('#main-product .overlay-buy_button');
    if (!buyBtn) return;

    if (stickyRevealObserver) stickyRevealObserver.disconnect();

    stickyRevealObserver = new IntersectionObserver(function (entries) {
      var entry = entries[entries.length - 1];
      if (entry.isIntersecting) {
        document.documentElement.classList.remove('sn-sticky-show');
      } else if (entry.boundingClientRect.bottom <= 0) {
        document.documentElement.classList.add('sn-sticky-show');
      }
      // else: below the viewport, not yet scrolled to â€” leave as-is.
    });

    stickyRevealObserver.observe(buyBtn);
  }, '#sticky-add-to-cart, #main-product .overlay-buy_button');

  // Omschrijving's heading is a real `.tabs-header.toggle` (Xtra's own
  // accordion system, scripts.js's semanticTabs()) â€” confirmed live it's
  // NOT a leftover visual: clicking it actually collapses the entire
  // Omschrijving+specs+benefits group (they share one `.tabs-inner`).
  // Requested: this heading should have no expand/collapse of its own â€”
  // "Lees meer" stays the only affordance for the description text.
  // scripts.js wires this via one delegated listener on the shared
  // `.m6tb`'s content wrapper (`tabs_content.addEventListener('click', ...)`,
  // matching by `.tabs-header` class, not by element identity), so it
  // can't be avoided by changing markup/classes without breaking
  // semanticTabs()'s own "does this item already have a header?" check
  // (removing the `.tabs-header` class would make it try to auto-generate
  // one). Stopping propagation here, directly on the heading itself
  // (target phase, before the event ever bubbles to the delegated
  // listener on the ancestor), reliably blocks it regardless of
  // attachment order â€” works for both mouse and keyboard-triggered clicks
  // (Enter on a focused link dispatches the same 'click' event), unlike a
  // pure `pointer-events: none` CSS approach which only blocks the mouse
  // path. Chevron itself is removed separately, in shopnest.css (CSS-only,
  // no JS needed for that part).
  SN.register('omschrijvingNoToggle', function (root) {
    var sel = ':is(#main-product .m6tb, #main-product ~ .m6tb) .tabs-header';
    var heading = (root && root.querySelector && root.querySelector(sel)) || document.querySelector(sel);
    if (!SN.claim(heading, 'noToggle')) return;
    heading.addEventListener('click', function (e) {
      // preventDefault is required here, not just stopPropagation: this
      // heading is a real `<a href="#">`. Xtra's own delegated handler
      // (scripts.js) calls e.preventDefault() itself right after toggling
      // the class â€” stopPropagation alone stops that handler from ever
      // running, which means the browser's OWN default action for a bare
      // `href="#"` (jump to the top of the page) fires unopposed. Found
      // live after this shipped: clicking the heading no longer collapsed
      // anything (correct) but scrolled to the top of the page (not
      // correct) â€” a regression this same fix introduced, not a
      // pre-existing issue.
      e.preventDefault();
      e.stopPropagation();
    });
  }, ':is(#main-product .m6tb, #main-product ~ .m6tb) .tabs-header');

  /* --- PDP INFO TABS (core edit #113) --------------------------------- âœ… DONE
     Converts the previously stacked Omschrijving / In het kort / Waarom
     klanten dit kiezen / Samenstelling / Gebruiksaanwijzing area into a
     real tab interface, desktop only.

     Deliberately NOT reusing Xtra's own semanticTabs() (scripts.js) for
     the actual tab-switching, even though it's already running on this
     exact `.m6tb` (confirmed live: `.tabs-initialized` present,
     `.tabs-header`/`.tabs-inner` auto-generated around the original
     content on load, regardless of the `.static` class â€” `.static`
     only skips semanticTabs()'s OWN header-click switching logic,
     confirmed by reading its source, not the structural wrapping).
     Two reasons: (1) semanticTabs() only knows how to switch between
     children of ONE tabs_content element â€” Samenstelling/
     Gebruiksaanwijzing come from a completely separate render pass
     (main-product-info.liquid, only_content_blocks: true, core edit
     #037), rendered as siblings AFTER `.m6tb` closes, not inside it at
     all; (2) this file already established the precedent of bypassing
     Xtra's generic tabs system for this exact area rather than
     configuring it to fit (see omschrijvingNoToggle, just above) â€”
     consistent with that judgment call, not a new direction.

     "In het kort" reuses `.w40.t45` directly as its panel â€” confirmed
     live it already stacks specs then benefits vertically (both
     `.sn-info-sec` children), exactly matching "benefits folded below
     the spec list, same panel," no content merging needed. "Omschrijving"
     reuses `.w60.t55` directly. Both already live inside the same
     `article.cols.b75` (Xtra's float-based column grid, screen.css) â€”
     no DOM move needed for either, just tagging + the width/float
     override in shopnest.css (`.cols > .w40/.w60` sets an explicit
     width% + float, which would otherwise leave the inactive column's
     share as blank space next to whichever panel is shown).

     Samenstelling/Gebruiksaanwijzing DO need moving â€” appended into the
     same `article.cols.b75` so all four panels share one parent and one
     show/hide mechanism regardless of origin. Found via the same
     `summary.sn-info-h` marker main-product-info.liquid already applies
     only to block.type == 'content' (not complementary_products, which
     shares the same `.accordion-a` wrapper shape) â€” an existing,
     reliable hook, no new one needed. Their native `<details>` toggle
     is blocked (same preventDefault pattern as omschrijvingNoToggle
     above) and forced `open`, since they're plain panels now â€” no
     accordion collapse of their own, matching the request exactly.

     Desktop only, checked once via matchMedia at init â€” not left to CSS
     alone, because this physically moves DOM nodes (the two content-
     block elements). Doing that unconditionally would touch mobile's
     markup/flow even if CSS then hid the result, and would also break
     the EXISTING mobile-only divider/spacing rules for these two blocks
     (shopnest.css targets them via `#main-product ~ .accordion-a.compact`,
     a sibling relationship that moving them into `.m6tb` would break).
     Skips entirely below 750px, leaving mobile's current stacked,
     always-visible layout â€” and its existing CSS â€” completely untouched. */
  SN.register('pdpInfoTabs', function (root) {
    if (!window.matchMedia('(min-width: 750px)').matches) return;

    var m6tbSel = ':is(#main-product .m6tb, #main-product ~ .m6tb)';
    var m6tb = (root && root.querySelector && root.querySelector(m6tbSel)) || document.querySelector(m6tbSel);
    if (!SN.claim(m6tb, 'pdpInfoTabs')) return;

    var article = m6tb.querySelector('article.cols');
    var kortPanel = null;
    var omschrijvingPanel = null;
    var panelHost = article;

    if (article) {
      kortPanel = article.querySelector('.w40.t45');
      omschrijvingPanel = article.querySelector('.w60.t55');
    } else {
      /* #279 — PATH A (no specs, no pros/cons — see shopnest.css's
         "SCOPING GOTCHA" note for the two Liquid paths). Here the first
         m6tbSel match is the GALLERY's desktop-only description footer
         (main-product-gallery.liquid), which this module previously
         claimed and abandoned — leaving it raw inside the STICKY
         .l4pr-container, where the slider ul computes to height 0 (its
         slides are absolutely positioned) and the footer floated up
         underneath the artwork: reported live as "Omschrijving" text
         bleeding across the thumbnail rail. Fix = move it (and its
         #032 scope-tag) to Path B's position, directly after
         #main-product, THEN build the same tabs from what it has:
         #section-info is the Omschrijving panel, content blocks join
         exactly as on Path B. The move alone already repairs the
         layout even when there aren't enough panels to tab. Bail
         untouched on anything unrecognized — native layout is the
         correct fallback there. */
      var mainProduct = document.getElementById('main-product');
      var sectionInfo = m6tb.querySelector('#section-info');
      if (!mainProduct || !m6tb.closest('.l4pr-container') || !sectionInfo) return;
      var aTag = m6tb.previousElementSibling;
      var aHasTag = aTag && aTag.classList && aTag.classList.contains('sn-scope-tag');
      mainProduct.parentNode.insertBefore(m6tb, mainProduct.nextSibling);
      if (aHasTag) mainProduct.parentNode.insertBefore(aTag, m6tb);
      omschrijvingPanel = sectionInfo;
      panelHost = sectionInfo.parentElement;
    }

    var contentBlocks = [];
    var sib = m6tb.nextElementSibling;
    while (sib) {
      if (sib.classList && sib.classList.contains('accordion-a') && sib.querySelector('summary.sn-info-h')) {
        contentBlocks.push(sib);
      }
      sib = sib.nextElementSibling;
    }

    var panels = [];
    if (kortPanel) panels.push({ key: 'kort', label: 'In het kort', el: kortPanel });
    if (omschrijvingPanel) panels.push({ key: 'omschrijving', label: 'Omschrijving', el: omschrijvingPanel });
    contentBlocks.forEach(function (block, i) {
      var summaryEl = block.querySelector('summary.sn-info-h');
      var labelSpan = summaryEl ? summaryEl.querySelector('span') : null;
      var label = (labelSpan ? labelSpan.textContent : (summaryEl ? summaryEl.textContent : '')).trim();
      panels.push({ key: 'content-' + i, label: label || ('Info ' + (i + 1)), el: block });
    });

    // Fewer than 2 panels: nothing to tab between, leave the original
    // (already-correct, un-tabbed) layout exactly as-is.
    if (panels.length < 2) return;

    /* #279 — Path A's panel carries its own "Omschrijving" heading (the
       gallery footer's mobile-hide h-tag); with a tab already labelled
       Omschrijving above it, that's a duplicate. Path B's panels never
       had one, so this is Path A-only, and only once tabs are real. */
    if (!article) {
      var aOwnHeading = omschrijvingPanel.querySelector('.mobile-hide');
      if (aOwnHeading) aOwnHeading.style.display = 'none';
    }

    contentBlocks.forEach(function (block) {
      var details = block.querySelector('details');
      if (details && !details.hasAttribute('open')) details.setAttribute('open', '');
      var summary = block.querySelector('summary');
      if (summary) {
        summary.addEventListener('click', function (e) {
          e.preventDefault();
        });
      }
      panelHost.appendChild(block);
    });

    var nav = document.createElement('div');
    nav.className = 'sn-pdp-tabs-nav';
    nav.setAttribute('role', 'tablist');

    panels.forEach(function (panel, i) {
      panel.el.classList.add('sn-tab-panel');
      panel.el.setAttribute('data-sn-tab-panel', panel.key);
      panel.el.classList.toggle('sn-active', i === 0);

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'sn-pdp-tab';
      btn.classList.toggle('sn-active', i === 0);
      btn.textContent = panel.label;
      btn.setAttribute('data-sn-tab', panel.key);
      btn.setAttribute('role', 'tab');
      btn.setAttribute('aria-selected', i === 0 ? 'true' : 'false');

      btn.addEventListener('click', function () {
        panels.forEach(function (p) {
          p.el.classList.toggle('sn-active', p.key === panel.key);
        });
        var tabs = nav.querySelectorAll('.sn-pdp-tab');
        for (var t = 0; t < tabs.length; t++) {
          var isActive = tabs[t] === btn;
          tabs[t].classList.toggle('sn-active', isActive);
          tabs[t].setAttribute('aria-selected', isActive ? 'true' : 'false');
        }
      });

      nav.appendChild(btn);
    });

    var scopeTag = m6tb.previousElementSibling;
    m6tb.parentNode.insertBefore(nav, m6tb);

    // The old "Productinformatie" scope-tag divider (core edit #035) is
    // now redundant with the tab nav's own bottom border serving the
    // same separator role. Hidden, not removed â€” if this init fails for
    // any reason before reaching this line, the scope-tag (and the rest
    // of the original layout) is simply left exactly as it was.
    if (scopeTag && scopeTag.classList.contains('sn-scope-tag')) {
      scopeTag.style.display = 'none';
    }

    // Marks a successful run as complete â€” shopnest.css hides the OLD
    // (pre-tab) layout pieces until this class lands, capped at 200ms
    // either way (core edit #114's own comment on the CSS side has the
    // full reasoning: same bounded-hide pattern already used for the
    // gallery, #112, after an open-ended version of this exact idea
    // made a different case worse, #111). Added last, once the whole
    // restructure is genuinely done â€” not at the top of this function â€”
    // so a mid-function error never leaves `.sn-tabs-ready` present
    // without the layout it claims to describe actually being ready.
    document.documentElement.classList.add('sn-tabs-ready');
  }, ':is(#main-product .m6tb, #main-product ~ .m6tb)');

  /* --- PDP: "Vaak samen gekocht" as a right column beside the info tabs
     (core edit #147) ---------------------------------------------------
     Requested: move "Vaak samen gekocht" (a genuinely separate, top-level
     Shopify section â€” `sections/section-featured-products.liquid`,
     schema `"tag": "article"`, sibling of the ENTIRE main-product section
     in the page, not a descendant of it) from sitting full-width below
     the tabs into a right column beside them, matching the hero row's own
     60/40 split. No existing pattern in this theme does this â€” `pdpInfoTabs`
     (above) only ever reorganizes elements WITHIN one section; this is the
     first cross-section DOM move here. Runs after `pdpInfoTabs` (both
     registration order, which `SN._runAll` preserves, and a runtime check
     for `.sn-pdp-tabs-nav`) since it needs the tab nav to already exist â€”
     if `pdpInfoTabs` bailed (fewer than 2 real panels), there's no tab row
     to pair with, so this bails too and "Vaak samen gekocht" is left in
     its original, full-width position untouched.

     Idempotency note, honestly documented rather than assumed solid: this
     doesn't use a single `SN.claim` marker the way every other init in
     this file does, because the two things it moves can each be
     independently re-rendered by the theme editor (`shopify:section:load`
     firing for `main-product` OR for the featured-products section on its
     own) and a stale claim on a since-replaced node would silently stop
     future re-parenting from happening. Instead: the wrapper
     (`.sn-pdp-columns`) is created once and reused across re-runs, and the
     featured section's heading + grid are re-parented into it every run
     regardless of where they currently sit (re-appending an element
     already inside its target parent is a harmless no-op, not a
     duplicate) â€” this handles a `main-product`-only or featured-products-
     only reload correctly. What ISN'T specifically handled: `pdpInfoTabs`
     rebuilding a second `.sn-pdp-tabs-nav` from scratch on a `main-product`
     reload without cleaning up the first one â€” verified this doesn't
     happen on ordinary page load and interaction; not separately verified
     against a live theme-editor section-reorder/reload of `main-product`
     itself, flagged here rather than silently assumed fine. */
  SN.register('pdpFeaturedColumn', function (root) {
    if (!window.matchMedia('(min-width: 750px)').matches) return;

    var nav = document.querySelector('.sn-pdp-tabs-nav');
    var m6tb = document.querySelector(':is(#main-product .m6tb, #main-product ~ .m6tb)');
    var featuredHeader = document.querySelector('.sn-featured-reco-section');
    var featuredList = featuredHeader && featuredHeader.nextElementSibling;

    if (!nav || !m6tb || !featuredHeader || !featuredList || !featuredList.classList.contains('l4cl')) return;

    var cols = document.querySelector('.sn-pdp-columns');
    var left, right;

    if (!cols) {
      cols = document.createElement('div');
      cols.className = 'sn-pdp-columns';
      left = document.createElement('div');
      left.className = 'sn-pdp-columns-left';
      right = document.createElement('div');
      right.className = 'sn-pdp-columns-right';
      cols.appendChild(left);
      cols.appendChild(right);
      nav.parentNode.insertBefore(cols, nav);
    } else {
      left = cols.querySelector('.sn-pdp-columns-left');
      right = cols.querySelector('.sn-pdp-columns-right');
    }

    left.appendChild(nav);
    left.appendChild(m6tb);
    right.appendChild(featuredHeader);
    right.appendChild(featuredList);

    // Requested layout inside the new column: 3-per-row, 2 rows for the
    // section's 6 cards. The grid's native width class (`w16`, 16.66% â€”
    // sized for its ORIGINAL full-width row, 6 cards on one line) is
    // still correct/tested Xtra CSS, just for the wrong column width now
    // â€” swapped for `w33` (33.33%, this same class-based system's own
    // 3-per-row value, already used and verified elsewhere on this PDP's
    // own card grids) rather than hand-rolling new width/gutter math.
    if (featuredList.classList.contains('w16')) {
      featuredList.classList.remove('w16');
      featuredList.classList.add('w33');
    }

    // The original featured-products section wrapper is now empty (its
    // heading + grid live in the right column instead) â€” hidden rather
    // than left as a stray empty block. Class-scoped, not an inline style
    // on the section's own `#shopify-section-*` id: that id is stable
    // per-instance, but re-hiding it by id after every possible reload
    // would need the same re-run-safety reasoning as above for no
    // benefit â€” the class is simpler and already unique to this section
    // type on this page.
    var featuredArticle = featuredHeader.closest('article[id^="shopify-section-"]');
    if (featuredArticle) featuredArticle.classList.add('sn-pdp-featured-moved');
  }, ':is(#main-product .m6tb, #main-product ~ .m6tb), .sn-featured-reco-section');

  /* --- PRODUCT CARDS: quickshop qty carry-through --------------------- âœ… DONE
     (core edit #083) Multi-variant cards now trigger the native quickshop
     drawer instead of a direct add (product-item.liquid) â€” this carries
     the card's own .sn-qv value into the drawer's quantity control once
     it renders, so "3 selected on the card" doesn't silently reset to 1
     the moment the drawer opens.

     Investigated live before writing this (custom-async.js, quickShop
     module): openQuickshop() fetches the clicked card's own product.url,
     pulls out that page's #main-product .m6pr wholesale, and injects it
     into #quickshop â€” string-replacing the section/form id so it can't
     collide with a real PDP on the same page. That means the drawer's
     quantity control is the exact same .sn-qsel component (core edit
     #016) as the real PDP, just re-IDed; both the input's `id` and its
     .sn-qsel's `data-sn-target` get the identical suffix appended (same
     source string, one blind replace), so they still resolve to each
     other correctly after injection â€” reading `data-sn-target` rather
     than assuming any fixed id is what makes this safe.
     handleQuickshopPanel's runHeavy() dispatches `semanticInputEvt` right
     after injection (same event this file already listens for its own
     re-init) â€” the only signal available that the drawer's markup exists.

     Deliberately does NOT depend on this listener running before or
     after the existing `semanticInput` -> SN._runAll one above: it calls
     qselBuildOptions itself after setting the input's value, so the
     popup's option list rebuilds with the carried-over quantity already
     marked selected regardless of which listener fires first â€” relying
     on registration order here would silently break if this file is
     ever reordered.

     Reads .sn-qv scoped to trigger.closest('.submit') â€” NOT card.querySelector,
     found live to matter: each card's add-row renders twice (a hidden
     figure-nested copy plus the visible body-placed one, same duplication
     already known from the qty/cart button work, core edit #081/#082), each
     with its own .sn-qv. A card-wide query matches whichever copy is FIRST
     in DOM order regardless of which one the shopper actually interacted
     with â€” silently reading the hidden copy's still-default "1" instead of
     the visible copy's real value. Scoping to the trigger's own .submit
     sidesteps this entirely: the clicked trigger and the qty display the
     shopper actually saw are always siblings in the same row.

     Reads the popup via sel._snPop, NOT sel.querySelector('.sn-qsel-pop') â€”
     found live to matter, the hard way: the qsel init above (SN.register
     ('qsel', ...)) reparents every .sn-qsel-pop to <body> as a permanent
     "portal" (see that section's own write-up) and stores the reference on
     sel._snPop precisely because of that move â€” a live querySelector from
     sel no longer finds it once reparented, since it's not a descendant of
     sel any more. That init is registered earlier in this file and so
     always runs first on the same semanticInput dispatch (confirmed live:
     by the time this listener ran, the drawer's fresh .sn-qsel had already
     had its pop moved out), which is exactly why the querySelector version
     silently found nothing and the carry-through never took effect. */

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.legacy-product-card [data-quickshop]');
    if (!trigger) return;
    var row = trigger.closest('.submit');
    var qv = row && row.querySelector('.sn-qv');
    SN._pendingQuickshopQty = qv ? qv.textContent.trim() : null;
  });

  window.addEventListener('semanticInput', function () {
    if (!SN._pendingQuickshopQty) return;
    var qty = SN._pendingQuickshopQty;
    SN._pendingQuickshopQty = null;

    var drawer = document.getElementById('quickshop');
    var sel = drawer && drawer.querySelector('[data-sn-qsel]');
    if (!sel) return;
    var targetSel = sel.getAttribute('data-sn-target');
    var input = targetSel ? document.querySelector(targetSel) : null;
    var pop = sel._snPop || sel.querySelector('.sn-qsel-pop');
    if (!input || !pop) return;

    input.value = qty;
    input.dispatchEvent(new Event('change', { bubbles: true }));
    qselBuildOptions(pop, input);
    var qvEl = sel.querySelector('.sn-qv');
    if (qvEl) qvEl.textContent = qty;
  });

  /* --- FOOTER: newsletter success state (core edit #163) ------------ âœ… DONE
     Reuses the exact success visual the theme already has for add-to-cart
     â€” the same checkmark path/stroke as buyButtonFlashAdded() above, the
     same `.sn-added` class, and the same "already busy?" dataset guard
     against a double submit â€” rather than inventing a second success
     language for the same idea.

     What it deliberately does NOT reuse is that helper's 1200ms revert
     timer. buyButtonFlashAdded() flashes and restores because the buy
     button stays usable; this one is terminal â€” reference/prototype.html's
     own nlSubmit() has no timer at all, it just swaps the label and
     disables. So there is no timing value to match here, and none was
     invented.

     Only the BUTTON is disabled client-side, never the input, even though
     the prototype disables both. The prototype's form never actually goes
     anywhere; this one is a real Shopify `{% form 'customer' %}` that
     POSTs and reloads, and a disabled input is omitted from form
     submission entirely â€” disabling it here would silently drop the
     subscriber's email address. The input does end up disabled in the
     finished success state: the section renders both that way server-side
     from `form.posted_successfully?` once the page comes back.

     Validation runs first and bails on an invalid/empty address (native
     `checkValidity`/`reportValidity`, no custom messaging) so the success
     state can never appear for a submission the browser is about to
     block. */
  SN.register('footerNewsletter', function (root) {
    var form = (root.querySelector && root.querySelector('.sn-ft-nlform-wrap')) ||
      document.querySelector('.sn-ft-nlform-wrap');
    if (!form) return;
    if (!SN.claim(form, 'ftNewsletter')) return;

    form.addEventListener('submit', function (e) {
      var input = form.querySelector('.sn-ft-nlinput');
      var btn = form.querySelector('.sn-ft-nlbtn');
      if (!btn) return;

      if (input && !input.checkValidity()) {
        e.preventDefault();
        input.reportValidity();
        return;
      }
      if (btn.dataset.snBusy) {
        e.preventDefault();
        return;
      }
      btn.dataset.snBusy = '1';

      btn.classList.add('sn-added');
      btn.innerHTML =
        '<svg class="sn-added-check" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12l5 5L20 6"/></svg>' +
        (btn.dataset.snDone || 'Aangemeld');
      // Left enabled until the browser has taken the submission: a
      // `disabled` submit button cancels the submit it was clicked for in
      // some browsers, so this is deferred rather than set inline.
      setTimeout(function () { btn.disabled = true; }, 0);
    });

    // Reset the confirmation as soon as the visitor starts another
    // signup. Without this the form is a dead end for the rest of the
    // page view: the reload lands on `?customer_posted=true`, the
    // section re-renders the success state server-side, and the button
    // reads "Aangemeld" forever with no way back to "Aanmelden" â€” which
    // is exactly how it was reported. Restores on `focus` as well as
    // `input` so the label flips the moment the field is clicked, not
    // only once a character is typed.
    var resetInput = form.querySelector('.sn-ft-nlinput');
    if (resetInput) {
      var restore = function () {
        var btn = form.querySelector('.sn-ft-nlbtn');
        if (!btn || !btn.classList.contains('sn-added')) return;
        btn.classList.remove('sn-added');
        btn.disabled = false;
        delete btn.dataset.snBusy;
        btn.textContent = btn.dataset.snIdle || 'Aanmelden';
      };
      resetInput.addEventListener('focus', restore);
      resetInput.addEventListener('input', restore);
    }
  }, '.sn-ft-nlform-wrap');

  /* --- HEADER: account icon beside the burger (#178) --- âœ… DONE, now in Liquid
     The JS that used to move the account <li> next to the burger lived here.
     Removed in #180: it ran on DOMContentLoaded, which is necessarily after the
     first paint, so the icon rendered once in its old right-hand position and
     then visibly jumped left. No amount of tuning fixes that â€” the gap is
     structural. The item is now emitted next to the burger by
     sections/header.liquid itself and returned to the right by CSS at
     â‰¥1001px, so its position is correct in the very first frame. */
  /* --- HEADER: Wishlist heart reserved slot (#202) --- âœ… DONE
     Fallback only. shopnest.css collapses `.sn-heart-slot` with
     `#header-inner:has(.Vtl-WishlistHeaderWrapper)`, whose style recalc is
     synchronous with the DOM mutation â€” so on engines that support `:has()`
     nothing here is ever needed, and the swap has no intermediate frame.

     This exists because the placeholder is PERMANENT. Without `:has()` the
     slot would never collapse and the header would show TWO hearts forever â€”
     a broken header, not a late paint. caniuse puts `:has()` at ~92% global
     support, which is not high enough to leave that failure mode unguarded.
     It adds `.sn-heart-live` to #header-inner, which the same CSS rule set
     also matches.

     Not a new dependency: the app's heart is injected by the app's own JS, so
     JS is already required for this element to exist at all.

     Idempotent via SN.claim, and re-runs on shopify:section:load like every
     other registration. The observer disconnects on first hit and gives up
     after 30s, so a page where the app never loads (or has been uninstalled)
     doesn't keep one alive â€” there the static heart simply remains, which is
     the correct fallback rendering rather than an empty gap. */
  /* THIRD-PARTY: WishlistSuite — PDP gallery hook (core edit #257).
     The app's "wishlist icon on product image" feature finds the image by a
     selector list (.product__media, .product-media, …) none of which exist
     in Xtra, then falls back to "largest img NOT inside a carousel" — and
     Xtra's gallery IS a Swiper, so the fallback EXCLUDED the real gallery
     and picked the biggest "Vaak samen gekocht" card image instead (read
     from the app's own wls-product-wishlist-icon.js source; the exclusion
     regex is /carousel|swiper|…/). Handing the gallery UL the first class
     from the app's OWN list makes its primary detection hit before the
     broken fallback runs. `.product-media` has zero occurrences in the
     theme's CSS/Liquid, so the class is inert for Xtra itself.
     ORDERING-SAFE: the app injects once at requestIdleCallback after
     window.load (no retry loop) — this deferred script runs well before
     that. Re-runs on shopify:section:load for editor re-renders. */
  /* THIRD-PARTY: WishlistSuite — PDP gallery hook (#258, restored in #270).
     #269 removed this on the assumption we could server-render the heart;
     Xtra's slider sweeps every child of ul.l4pr into a slide, so the app
     injects it after all — which means both jobs are needed again:
     (a) hand the gallery the class the app's image-detector looks for, and
     (b) adopt the body-appended button into the gallery so our CSS can pin
     it. See the #257/#258 comments in shopnest.css for the full story. */
  SN.register('wlsGalleryHook', function (root) {
    var scope = root.querySelector ? root : document;
    var gallery = scope.querySelector('#main-product .l4pr') ||
      document.querySelector('#main-product .l4pr');
    if (gallery && !gallery.classList.contains('product-media')) {
      gallery.classList.add('product-media');
    }
    if (gallery && !document.body.hasAttribute('data-sn-wls-adopt')) {
      document.body.setAttribute('data-sn-wls-adopt', '1');
      var adopt = function () {
        var btn = document.querySelector('.wls-product-page-image-icon');
        var g = document.querySelector('#main-product .l4pr');
        if (btn && g && btn.parentElement !== g) g.appendChild(btn);
      };
      adopt();
      new MutationObserver(adopt).observe(document.body, { childList: true });
    }
  });

  /* THIRD-PARTY: WishlistSuite — PDP heart, state only (#269).
     The button itself is server-rendered by main-product-gallery.liquid now,
     and the app drives clicks through its own document-level delegation, so
     nothing here creates, moves or styles it — the #258 adoption observer and
     the `product-media` class hack that made the app FIND the gallery are
     both gone with it, because the app no longer injects anything here.
     One job is left, and it is the only one a server render genuinely cannot
     do: a visitor's wishlist is per-browser, so "already wishlisted" is
     unknown at render time. The app caches it in localStorage under
     'wishlistVariantIds' (a JSON array, written by its own
     saveWishlistedIdsToStorage) — read it once and reflect it, using the
     same attributes the app's updateHeartButtonState() writes, so its later
     syncs simply overwrite ours with no conflict. Cheap, synchronous, no
     observers, and a no-op when the list is empty or storage is blocked. */
  SN.register('wlsPdpHeartState', function (root) {
    var scope = root.querySelector ? root : document;
    var btn = scope.querySelector('.wls-product-page-image-icon') ||
      document.querySelector('.wls-product-page-image-icon');
    if (!btn || !SN.claim(btn, 'wlsPdpHeartState')) return;
    var ids;
    try {
      ids = JSON.parse(window.localStorage.getItem('wishlistVariantIds') || '[]');
    } catch (e) {
      return; // storage blocked / bad JSON — leave the server-rendered state
    }
    if (!ids || !ids.length) return;
    var wanted = [btn.getAttribute('data-variant-id'), btn.getAttribute('data-product-id')];
    var hit = false;
    for (var i = 0; i < ids.length && !hit; i++) {
      for (var j = 0; j < wanted.length; j++) {
        if (wanted[j] && String(ids[i]) === String(wanted[j])) { hit = true; break; }
      }
    }
    if (!hit) return;
    btn.setAttribute('data-wishlisted', 'true');
    btn.setAttribute('aria-pressed', 'true');
  });

  /* (#259's wlsHeaderSlot module lived here — it mirrored the app's slot
     into a .sn-wh-live class so a no-:has() engine could still collapse the
     first-paint placeholder, and it repointed the placeholder's dead
     "#wishlist" href. REMOVED by #264: the header heart is now Xtra's own
     server-rendered li, given a real href in header.liquid, and the app's
     header block is display:none. There is no placeholder, no handover and
     no second heart, so nothing here to keep in sync — the whole class of
     bug this module existed to manage (including the #263 latch that could
     blank the heart entirely) is designed out rather than patched.) */

  SN.register('heartSlot', function (root) {
    var inner = (root.querySelector && root.querySelector('#header-inner')) ||
      document.querySelector('#header-inner');
    if (!SN.claim(inner, 'heartSlot')) return;

    // Per-breakpoint readiness, matching the CSS :has() keying (#206) â€” the two
    // breakpoints need DIFFERENT signals because the app inserts the wrapper
    // EMPTY and fills it ~44ms later (cold trace 2026-08-16: wrapper t=1074,
    // svg t=1118):
    //  - DESKTOP: wrapper width > 0. Our own CSS sizes the wrapper (32.54px)
    //    the instant it enters, and the art lives on the wrapper's ::before
    //    (#204) â€” so wrapper-insert IS the width-neutral, art-continuous
    //    moment to collapse the slot. Waiting for the svg here would leave a
    //    ~44ms window where slot + sized wrapper both occupy and #search
    //    shrinks 32.53px â€” the reflow this whole feature exists to prevent.
    //  - MOBILE (â‰¤760px): the rendered svg. There the wrapper stays 0-wide
    //    until the app's subtree lands, and the art carrier (IconWrapper) is
    //    INSIDE it â€” collapsing on wrapper-insert blanked the heart for a
    //    frame (the hearts=0 blink caught on the 390px filmstrip). The svg's
    //    own non-zero box is the closest signal to "actually painted".
    // A MutationObserver cannot see the later size change, so the callback
    // re-checks on rAF until the relevant box is non-zero.
    var ready = function () {
      var w = document.querySelector('.Vtl-WishlistHeaderWrapper');
      if (!w || w.getBoundingClientRect().width <= 0) return false;
      /* â‰¤1000, not the original 760 (#219): everywhere the art rides the
         IconWrapper (phone AND tablet band), "wrapper has width" is not
         "heart is painted" â€” measured at 820/iPad UA, the app parks a 16px
         wrapper ~600ms before the svg lands, which fired this gate early and
         collapsed the placeholder into a heartless window. Only â‰¥1001px,
         where OUR CSS sizes the wrapper and the art is the wrapper's own
         ::before, is width alone the honest signal. */
      if (window.matchMedia('(max-width: 1000px)').matches) {
        var svg = document.querySelector('svg.Vtl-WishlistHeader__HeartIconWrapper');
        return !!svg && svg.getBoundingClientRect().width > 0;
      }
      return true;
    };
    var mark = function () {
      if (!ready()) return false;
      inner.classList.add('sn-heart-live');
      return true;
    };
    if (mark()) return;

    var tries = 0;
    var poll = function () {
      if (mark() || ++tries > 240) return;   // ~4s at 60fps, then give up
      requestAnimationFrame(poll);
    };
    var mo = new MutationObserver(function () {
      if (mark()) { mo.disconnect(); return; }
      if (document.querySelector('.Vtl-WishlistHeaderWrapper')) {
        mo.disconnect();   // it exists; rAF now waits for it to be painted
        poll();
      }
    });
    mo.observe(inner, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 30000);
  }, '#header-inner');

  /* --- (others as needed) ------------------------------------------ â¬œ TODO */

  /* --- SN-DEBUG (core edit #210, TEMPORARY â€” strip once its log stays empty)
     Header layout-shift trap: records every browser-reported layout shift
     whose source rect touches the header band (y < 150) into
     `ShopNest.debugShifts` and mirrors it to console.debug. This is Chrome's
     own CLS machinery (buffered, so shifts from before this deferred script
     ran are recovered), not polling â€” if the account icon ever really moves,
     the entry names the element and both rects. Installed alongside #210's
     structural pin as its proof-over-time: check `ShopNest.debugShifts` in
     the console after a refresh where a nudge was seen. Empty array = the
     browser recorded no layout motion. */
  try {
    SN.debugShifts = [];
    new PerformanceObserver(function (list) {
      list.getEntries().forEach(function (e) {
        (e.sources || []).forEach(function (s) {
          var p = s.previousRect, r = s.currentRect;
          if ((r && r.y < 150) || (p && p.y < 150)) {
            var rec = {
              t: Math.round(e.startTime),
              value: e.value,
              node: (s.node && s.node.tagName)
                ? s.node.tagName.toLowerCase() + (s.node.id ? '#' + s.node.id : '')
                : String(s.node),
              prev: p ? [p.x, p.y, p.width, p.height] : null,
              cur: r ? [r.x, r.y, r.width, r.height] : null,
            };
            SN.debugShifts.push(rec);
            console.debug('[SN-DEBUG #210] header layout shift', rec);
          }
        });
      });
    }).observe({ type: 'layout-shift', buffered: true });
  } catch (e) { /* older engines: no layout-shift entry type â€” trap is a no-op */ }

  /* MOBILE MENU DRAWER decoration + state (core edit #228) ------------------
     Partner of shopnest.css's #228 block: restyles Xtra's own #nav drawer to
     the approved prototype WITHOUT touching Liquid. Three jobs, all scoped to
     #nav only (the desktop menubar #nav-bar is never selected):

     1. LABEL WRAP + ICON SLUG (level 1): each top-level row's text nodes get
        wrapped in span.sn-mm-lbl (the Aanbiedingen pill needs a stylable
        element around the bare text), and the anchor is stamped
        data-sn-mi="<title-slug>" so CSS can key icons for items whose URL is
        ambiguous (Nieuw/Cadeaus/Blogs all point at bare /collections today).

     2. "BEKIJK ALLES" rows: every drillable li (has a real parent link, a
        panel ul, and a drill toggle) gets a generated last row
        <li.sn-mm-va><a href=parent>Bekijk alles</a> â€” cloned from the REAL
        parent URL, never hand-maintained. NL literal is deliberate: the
        storefront is NL-only and the theme's own view_all locale string
        ("Alle categorieÃ«n") is the wrong label for this row per the approved
        prototype. Idempotent via the .sn-mm-va presence check.

     3. STATE CLASSES: Xtra marks the open panel chain with li.mtoggle but
        gives the CSS no drawer-level hook. A MutationObserver mirrors the
        state: #nav.sn-mm-sub while any panel is open, .sn-mm-path on the
        open leaf's ancestor lis, .sn-mm-hide on all siblings of the open
        chain â€” so shopnest.css can flow ONE panel where the list was, in
        every browser (no :has() dependency). apply() is diff-based (only
        touches classes that actually change), so the observer reaching a
        steady state generates no mutations and cannot loop. */
  SN.register('mobileMenu', function () {
    var nav = document.getElementById('nav');
    if (!nav) return;
    var mainUl = nav.querySelector('ul[data-type="main-nav"]');

    // -- 1) level-1 label wrap + slug stamp (idempotent per anchor)
    if (mainUl) {
      var tops = mainUl.querySelectorAll(':scope > li > a:not(.toggle)');
      Array.prototype.forEach.call(tops, function (a) {
        var label = (a.textContent || '').replace(/\s+/g, ' ').trim();
        if (!label) return;
        var slug = label.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
        a.setAttribute('data-sn-mi', slug);
        // the li too: CSS has no parent selector, and per-item ROW rules
        // (e.g. hiding Blogs in the drawer, #230) need the li
        if (a.parentElement && a.parentElement.tagName === 'LI') a.parentElement.setAttribute('data-sn-mi', slug);
        if (!a.querySelector('.sn-mm-lbl')) {
          var span = document.createElement('span');
          span.className = 'sn-mm-lbl';
          var moved = false;
          Array.prototype.slice.call(a.childNodes).forEach(function (n) {
            if (n.nodeType === 3 && n.textContent.trim()) {
              if (!moved) { a.insertBefore(span, n); moved = true; }
              span.appendChild(n);
            } else if (n.nodeType === 1 && n.classList && n.classList.contains('overlay-sale')) {
              // sale-highlight span: fold it into the label wrapper too
              if (!moved) { a.insertBefore(span, n); moved = true; }
              span.appendChild(n);
            }
          });
          if (!moved) span.parentNode === a && a.removeChild(span);
          /* #394 - trim the whitespace the original markup carried into the span.
             It matters only now that this label can be CENTRED: as a panel title the
             span is a flex item, so a trailing space is part of its measured width and
             pushed the visible glyphs ~2.5px left of centre at level 2. Level 3 never
             had it, because its title is a bare text node and trailing whitespace at
             the end of an anonymous flex item collapses. Only the first and last text
             nodes are touched, so an inner element (the sale chip) is untouched, and
             re-running this is a no-op. */
          if (moved) {
            var lblFirst = span.firstChild, lblLast = span.lastChild;
            /* Character loop, not a regex: a backslash escape does not survive
               this file's edit pipeline intact (the same trap the price parser
               hit with its literal dot), and a mangled /^s+/ would have eaten
               leading LETTERS instead of spaces. This cannot be mis-escaped. */
            var lblWs = ' \t\n\r\f';
            if (lblFirst && lblFirst.nodeType === 3) {
              var lblA = lblFirst.nodeValue;
              while (lblA.length && lblWs.indexOf(lblA.charAt(0)) > -1) lblA = lblA.slice(1);
              if (lblA !== lblFirst.nodeValue) lblFirst.nodeValue = lblA;
            }
            if (lblLast && lblLast.nodeType === 3) {
              var lblB = lblLast.nodeValue;
              while (lblB.length && lblWs.indexOf(lblB.charAt(lblB.length - 1)) > -1) lblB = lblB.slice(0, -1);
              if (lblB !== lblLast.nodeValue) lblLast.nodeValue = lblB;
            }
          }
        }
      });
    }

    // -- 2) generated "Bekijk alles" rows
    var drillable = nav.querySelectorAll('li.sub');
    Array.prototype.forEach.call(drillable, function (li) {
      var parentA = li.querySelector(':scope > a:not(.toggle)');
      var panelUl = li.querySelector(':scope > ul');
      var hasDrill = li.querySelector(':scope > a.toggle');
      if (!parentA || !panelUl || !hasDrill) return;
      // panels with no NATIVE back element (Xtra only renders toggle-back on
      // top-level items) get a generated one, so level-3 panels can go back
      // too. Click = re-toggling Xtra's own (hidden-when-open) drill anchor,
      // which runs the theme's real close path â€” no re-implemented state.
      if (!li.querySelector(':scope > a.toggle-back') && !li.querySelector(':scope > a.sn-mm-back')) {
        var back = document.createElement('a');
        back.className = 'sn-mm-back';
        back.setAttribute('href', '#');
        back.setAttribute('role', 'button');
        back.setAttribute('aria-label', 'Terug');
        back.addEventListener('click', function (e) {
          e.preventDefault();
          var t = li.querySelector(':scope > a.toggle:not(.toggle-back)');
          if (t) t.click();
        });
        // APPENDED, never prepended: Xtra's async init detects submenu items
        // by inspecting a li's leading children â€” a foreign first child made
        // it skip the runtime `sub` class entirely (found the hard way; the
        // back control's DOM position is irrelevant, CSS absolutifies it).
        li.appendChild(back);
      }
      var href = parentA.getAttribute('href');
      if (!href || href.charAt(0) !== '/') return; // '#'/'./' parents: no row
      if (panelUl.querySelector(':scope > li.sn-mm-va')) return;
      // stand down if the MERCHANT added a manual "Bekijk alles" item in the
      // admin menu (seen live 2026-08-19, href="/") â€” no double rows. The
      // generated row is preferred (it carries the real parent URL); the
      // manual admin items can be deleted, and this then takes over.
      var manual = false;
      Array.prototype.forEach.call(panelUl.querySelectorAll('a'), function (x) {
        // only THIS panel's rows count â€” anchors living inside a deeper
        // drillable item (li.sub) belong to the next level's panel
        var owner = x.closest ? x.closest('li.sub') : null;
        if (owner && owner !== li && panelUl.contains(owner)) return;
        if ((x.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase() === 'bekijk alles') manual = true;
      });
      if (manual) return;
      var va = document.createElement('li');
      va.className = 'sn-mm-va';
      var vaA = document.createElement('a');
      vaA.setAttribute('href', href);
      vaA.textContent = 'Bekijk alles';
      va.appendChild(vaA);
      panelUl.appendChild(va);
    });

    // TOMBSTONE (#232, full revert). Nothing in this module touches panel-
    // title tap behaviour any more. #231 fix 3 put a capture-phase click
    // listener on #nav here to force level-2 titles to navigate (Xtra's
    // delegated tap handling swallows clicks on li.inactive-mobile
    // anchors); #232's first pass then replaced it with a CSS
    // pointer-events neutraliser. Both are removed: titles now do exactly
    // what the stock theme does, uncorrected in either direction, by
    // explicit decision. The parent collection is reached via the
    // "Bekijk alles" row above.

    // -- 3) open-panel state mirror
    if (nav.dataset.snMmObs) return;
    nav.dataset.snMmObs = '1';
    var applying = false;
    var setCls = function (el, cls, on) {
      if (el.classList.contains(cls) !== on) el.classList.toggle(cls, on);
    };
    var apply = function () {
      var open = nav.querySelectorAll('li.mtoggle');
      var leaf = null;
      Array.prototype.forEach.call(open, function (l) {
        if (!l.querySelector('li.mtoggle')) leaf = l;
      });
      setCls(nav, 'sn-mm-sub', !!leaf);
      var keepPath = [];
      var keepHide = [];
      if (leaf) {
        var node = leaf;
        while (node && node !== nav) {
          if (node.tagName === 'LI') {
            if (node !== leaf) keepPath.push(node);
            var sibs = node.parentElement ? node.parentElement.children : [];
            Array.prototype.forEach.call(sibs, function (s) {
              if (s !== node && s.tagName === 'LI') keepHide.push(s);
            });
          }
          node = node.parentElement;
        }
      }
      Array.prototype.forEach.call(nav.querySelectorAll('li.sn-mm-path'), function (el) {
        if (keepPath.indexOf(el) === -1) setCls(el, 'sn-mm-path', false);
      });
      keepPath.forEach(function (el) { setCls(el, 'sn-mm-path', true); });
      Array.prototype.forEach.call(nav.querySelectorAll('li.sn-mm-hide'), function (el) {
        if (keepHide.indexOf(el) === -1) setCls(el, 'sn-mm-hide', false);
      });
      keepHide.forEach(function (el) { setCls(el, 'sn-mm-hide', true); });
      // panels replace the scroll position context: jump to top on change
      if (leaf && nav.scrollTop > 0) nav.scrollTop = 0;
    };
    var scheduled = false;
    new MutationObserver(function () {
      if (applying || scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        applying = true;
        try { apply(); } finally { applying = false; }
      });
    }).observe(nav, { subtree: true, attributes: true, attributeFilter: ['class'] });
    apply();
  });

  /* ------------------------------------------------------------------
     THIRD-PARTY: Wishlist by Square - PDP gallery heart (core edit #255).

     The app injects its heart INSIDE one gallery slide. Its own config
     says so (window.vtlsLiquidData.documentInjectors, injector "18":
     selector ".swiper-slide" plus .find("picture").parent()), which is
     why the heart vanished on every image except the first - it was
     never missing, it was riding slide 1 off-screen.

     Fix: MOVE that node into ".swiper-outer", the gallery container
     Swiper builds. Moved, never cloned - a clone gets the markup but not
     the app's click listeners, i.e. a dead heart. Moving keeps the very
     same element, so the app's handlers, ids and state come along.

     Also strips the inline "left: 91.0569%" the app writes (an inline
     style no stylesheet can outrank) and keeps stripping it if the app
     writes it again - hence the style attributeFilter on the observer.

     Idempotent: after the first move parentElement === host, so repeat
     calls (including ones our own DOM writes trigger) change nothing and
     the observer settles instead of looping.
     ------------------------------------------------------------------ */
  SN.register('pdpGalleryHeart', function (root) {
    var scope = root && root.querySelector ? root : document;
    var gallery = scope.querySelector('#main-product .l4pr') || document.querySelector('#main-product .l4pr');
    if (!gallery) return;
    if (!SN.claim(gallery, 'pdpGalleryHeart')) return;

    var pin = function () {
      var found = gallery.querySelectorAll('.Vtl-WishlistIcon__ProductPageWrapper');
      if (!found.length) return;
      /* HOST = the ACTIVE slide's image anchor, not the gallery container.
         Moving the heart OUT of the slides (the obvious fix, and the first
         build here) is unwinnable: the app re-injects whenever its target
         `.swiper-slide` has no heart, our code then adopted that new node
         and deleted the pinned one, and the two watchers ping-ponged at
         ~110ms forever (measured: x 559<->603, svg blinking each cycle).
         Keeping the heart INSIDE a slide leaves the app's own condition
         satisfied - it just has to be the slide the shopper can see. */
      var active = gallery.querySelector('.swiper-slide-active');
      var host = (active && active.querySelector('a')) || active
        || gallery.querySelector('.swiper-outer') || gallery;
      // NEVER two hearts: keep the first, drop any later re-injection.
      var keep = found[0];
      for (var i = 1; i < found.length; i++) {
        if (found[i] !== keep && found[i].parentElement) {
          found[i].parentElement.removeChild(found[i]);
        }
      }
      if (keep.parentElement !== host) {
        host.appendChild(keep);
        keep.classList.add('sn-pdp-heart-pinned');
      }
      // Deliberately NOT touching keep.style. The first build stripped the
      // app's inline left/top here; that made the app re-render and re-apply
      // them, and this observer stripped again - a ~110ms oscillation
      // (measured x 559<->603 with the svg blinking out each cycle).
      // shopnest.css overrides the inline value in the cascade instead, so
      // nothing fights and the heart holds still.
      // Only claim "live" once the art really has width - a wrapper with
      // zero-width contents would collapse the placeholder into a gap
      // (the #206 heartless-window bug, repeated here).
      var art = keep.querySelector('svg');
      if (art && art.getBoundingClientRect().width > 0) {
        gallery.classList.add('sn-pdp-heart-live');
      }
    };

    pin();
    try {
      new MutationObserver(pin).observe(gallery, {
        // childList only: watching the app's style writes was the other
        // half of the oscillation loop described above.
        childList: true,
        subtree: true,
      });
    } catch (e) {}
  });

  // First load. Placed HERE â€” after every SN.register(...) call above â€”
  // not up near SN.ready's own definition, where it used to live. Found
  // while investigating the load-flash bug this reveal logic exists to fix:
  // confirmed live that document.readyState is often already past 'loading'
  // (e.g. 'interactive') by the time this script's own top-level code runs
  // â€” normal for a `defer` script queued behind larger ones (Xtra's
  // custom.js) â€” which means SN.ready's immediate-execution branch used to
  // fire right where this call used to sit, at the TOP of the file, BEFORE
  // any SN.register(...) call below it had executed. SN._inits was still
  // empty, so that first _runAll(document) pass silently initialized
  // NOTHING â€” for every section, not just this one. Never surfaced before
  // because other triggers (Xtra's 'semanticInput' event, shopify:
  // section:load) eventually cover for it; only became visible as an
  // actual flash once a feature (this one) needed to run as close to first
  // paint as possible. Moving the call to after every registration fixes
  // the initial-load path for all of them.
  SN.ready(function () {
    try {
      SN._runAll(document);
    } finally {
      qselRevealRow();
      // Anti-flash reveal for the PDP info-tabs region (core edit #158).
      // shopnest.css hides the OLD (pre-tabs) layout â€” scope-tag, .m6tb,
      // the content accordions, and the "Vaak samen gekocht" section â€”
      // until this class lands. It marks "the first-load init pass is
      // over", NOT "it succeeded": that's why it's here in the `finally`
      // and not inside pdpInfoTabs next to `.sn-tabs-ready`. Two reasons.
      // (1) It must land even if an init throws or deliberately bails
      // (fewer than 2 real panels), otherwise the CSS would hide that
      // content until its own timeout â€” the failure mode this replaces.
      // (2) It must land AFTER the whole pass, not mid-way:
      // `.sn-tabs-ready` is set by pdpInfoTabs before pdpFeaturedColumn
      // has moved "Vaak samen gekocht", so revealing on that would just
      // swap one flash for a shorter one.
      // Runs at script-execution time (readyState is normally already
      // past 'loading' for this deferred script) or on DOMContentLoaded
      // otherwise â€” either way, as early as the restructure can possibly
      // be done, which is the whole point.
      document.documentElement.classList.add('sn-tabs-settled');
    }
  });


  /* --- wishlist page: strip the currency symbol from prices (#337) --------
     Requested "remove euro symbol in the price". Unlike the PDP old price
     (#299, a Liquid filter swap), these strings are rendered by WishlistSuite
     at runtime — there is no template to change and CSS cannot remove part of
     a text node, so this is the only lever.
     Scoped hard: it only runs on the wishlist page, only inside the app's own
     block, and only on the two price elements. The observer is attached to
     that block rather than to document, because the app re-renders its list
     on every add/remove/list-switch and a one-shot pass would be undone.
     No infinite loop: writing textContent re-triggers the observer, but the
     next pass finds no symbol left and writes nothing, so it settles after
     one extra tick. If the block has not been injected yet (the app renders
     late), a short-lived body observer waits for it and then disconnects. */
  SN.register('wlsStripCurrency', function () {
    /* #367 — the shared page (/apps/wlsp/shared) shows the same prices and was
       still printing the euro sign, so the guard covers both surfaces now. */
    if (!/wishlistsuite-wishlist|\/apps\/wlsp\//.test(location.pathname)) return;

    var SEL = '.wls-price, .wls-compare-price';

    function clean(block) {
      var nodes = block.querySelectorAll(SEL);
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        var txt = el.textContent;
        if (txt.indexOf('\u20AC') === -1) continue;
        el.textContent = txt.replace(/\u20AC/g, '').replace(/\s+/g, ' ').trim();
      }
    }

    function attach() {
      /* #367 — .wls-page-wrapper, not .wls-list-block-root: the shared page has
         no block root (that is the whole reason #364 re-scoped the CSS), so
         anchoring here is what makes this run on both. */
      var block = document.querySelector('.wls-page-wrapper');
      if (!block) return false;
      if (!SN.claim(block, 'wlsStripCurrency')) return true;
      clean(block);
      new MutationObserver(function () { clean(block); })
        .observe(block, { childList: true, subtree: true, characterData: true });
      return true;
    }

    if (attach()) return;
    var wait = new MutationObserver(function () { if (attach()) wait.disconnect(); });
    wait.observe(document.body, { childList: true, subtree: true });
  });


  /* --- wishlist page: close the item menu on scroll (#345) ----------------
     Requested: the remove menu should go away when the page is scrolled, not
     only when an option is chosen. The app has no such behaviour of its own.
     It closes the menu by its OWN outside-click handler — verified live that a
     programmatic body click sets wls-popup-open false and display none — so
     that is what this triggers, rather than stripping the class ourselves.
     The distinction matters: the app tracks the open item in _popupItemId /
     _popupHandle, and yanking the class behind its back would leave it
     believing a menu is still open, which can swallow the next tap on the same
     button. Going through its handler keeps its state honest.
     A 6px threshold ignores the jitter that opening the menu can itself cause
     (the button is scrolled into view first), so the menu cannot close in the
     same gesture that opened it. Listener is passive and does nothing at all
     while no menu is open. */
  SN.register('wlsClosePopupOnScroll', function () {
    /* #371 — widened with wlsCartFeedback: the shared page now raises the same
       toast, so it needs the same scroll dismissal. */
    if (location.pathname.indexOf('wishlistsuite-wishlist') === -1 &&
        location.pathname.indexOf('/apps/wlsp/') === -1) return;
    if (SN._wlsScrollClose) return;
    SN._wlsScrollClose = true;

    /* #346 — the guard anchors on the MOMENT THE MENU OPENED, not on a rolling
       last position. With a rolling baseline the menu closed itself the instant
       it appeared: bringing the button into view is itself a (smooth) scroll,
       and its remaining frames arrive AFTER the menu opens, so they read as a
       deliberate scroll and dismissed it — the menu could not be opened at all.
       Now the first scroll frame seen while open only records the baseline, and
       dismissal needs BOTH 400ms elapsed and 20px of travel from that point, so
       momentum settling cannot close what the same gesture just opened. */
    /* #347 — the baseline is captured on the TAP THAT OPENS the menu, not on
       the first scroll frame after it. Deriving it from a scroll frame failed
       for an instant jump: a programmatic or momentum-free scroll can deliver a
       SINGLE event, which was spent recording the baseline and so never closed
       anything (verified: a 300px jump left the menu open). Anchoring at the
       tap means the very first scroll frame already carries the full delta.
       Capture phase, so it still runs if the app stops propagation. */
    var openY = null;
    var openT = 0;
    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest && e.target.closest('.wls-item-menu-btn');
      if (!t) return;
      openY = window.pageYOffset;
      openT = Date.now();
    }, true);

    window.addEventListener('scroll', function () {
      if (openY === null) return;
      if (!document.querySelector('.wls-item-popup.wls-popup-open')) { openY = null; return; }
      if (Date.now() - openT < 400) return;
      if (Math.abs(window.pageYOffset - openY) < 20) return;
      openY = null;
      document.body.click();
    }, { passive: true });
  });


  /* --- wishlist page: hero copy (#348) ------------------------------------
     The headline/subtitle are rendered by WishlistSuite, and edits made in the
     app were reported as not reaching the storefront, so the copy is set here.
     Same mechanism as the currency strip: scoped to this page, driven by an
     observer because the app re-renders the block.
     The login note is handled by replacing ONLY its leading text node, so the
     app's own <a> elements — and therefore its login/register URLs — survive
     untouched; rewriting the whole node would have destroyed both links.
     TRADE-OFF, stated plainly: while this runs, the hero text can no longer be
     changed from the app admin. Remove this module to hand it back. */
  SN.register('wlsHeroCopy', function () {
    if (location.pathname.indexOf('wishlistsuite-wishlist') === -1) return;

    var COPY = {
      /* #349 — .wls-hero-main dropped: that line is hidden in CSS now, so
         writing copy into it would be dead work re-run on every re-render. */
      '.wls-hero-kicker': 'Mijn verlanglijst',
      '.wls-hero-subtitle': 'Log in om je favorieten op te slaan en ze altijd en overal te openen!'
    };

    function apply(block) {
      for (var sel in COPY) {
        var el = block.querySelector(sel);
        if (el && el.textContent.trim() !== COPY[sel]) el.textContent = COPY[sel];
      }
      /* #357 — the empty-state CTA points at the real all-categories page.
         /collections is that page on this store (verified live: 200, its <h1>
         reads "Alle categorieen"); the menu entry with the same label is a
         drawer toggle with href="./" and goes nowhere, so it could not be
         copied. Set here rather than in CSS because an href is markup, and
         re-applied by the same observer that owns the hero copy so it survives
         the app re-rendering its block. */
      /* #377 — the wishlist page signals the same ready class as the shared page.
         The hide is now unconditional on .wls-page-wrapper (see the CSS note), so
         without this the wishlist list would sit hidden until the 1400ms fallback
         fired. Set here, after the hero copy has been applied, which is the point
         at which nothing English remains on this page. */
      document.documentElement.classList.add('sn-wls-copy-ready');

      var emptyCta = block.querySelector('.wls-empty-cta');
      if (emptyCta && emptyCta.getAttribute('href') !== '/collections') {
        emptyCta.setAttribute('href', '/collections');
      }

      /* #364 — share links rebuilt with PROPER ENCODING, which is the actual
         reason Facebook 'opened but did not share': the app pastes the share URL
         into `sharer.php?u=` RAW, and that URL carries its own query string
         (`/shared?token=...`). Facebook therefore parsed the token as its OWN
         parameter and received a URL with no token — a shared list with nothing
         in it. Encoding the URL fixes Facebook, and the same bug was latent in
         the X and WhatsApp links, so all four are rebuilt from one encoded value.
         The mail subject also becomes Dutch (was the app's "My Wishlist").
         Idempotent: the URL is re-read from our own rewritten mailto href, so
         repeated runs on re-render produce the same result. */
      var mailA = block.querySelector('.wls-share-icon-btn[href^="mailto"]');
      var m = mailA && (mailA.getAttribute('href') || '').match(/body=(.+)$/);
      if (m) {
        var shareUrl = decodeURIComponent(m[1]);
        var enc = encodeURIComponent(shareUrl);
        var title = encodeURIComponent('Mijn verlanglijst');
        var put = function (sel, href) {
          var el = block.querySelector(sel);
          if (el && el.getAttribute('href') !== href) el.setAttribute('href', href);
        };
        put('.wls-share-icon-btn[href^="mailto"]', 'mailto:?subject=' + title + '&body=' + enc);
        put('.wls-share-icon-btn[href*="facebook.com"]', 'https://www.facebook.com/sharer/sharer.php?u=' + enc);
        put('.wls-share-icon-btn[href*="twitter.com"], .wls-share-icon-btn[href*="x.com"]',
            'https://twitter.com/intent/tweet?url=' + enc + '&text=' + title);
        put('.wls-share-icon-btn[href*="whatsapp"]',
            'https://api.whatsapp.com/send?text=' + encodeURIComponent('Mijn verlanglijst ' + shareUrl));
        var anchors = block.querySelectorAll('.wls-share-icon-btn');
        for (var s2 = 0; s2 < anchors.length; s2++) {
          if (anchors[s2].getAttribute('target') !== '_blank') {
            anchors[s2].setAttribute('target', '_blank');
            anchors[s2].setAttribute('rel', 'noopener');
          }
        }
      }

      var note = block.querySelector('.wls-hero-login-note');
      if (note && note.firstChild && note.firstChild.nodeType === 3 &&
          note.firstChild.nodeValue.trim() !== '') {
        note.firstChild.nodeValue = '';
      }
    }

    function attach() {
      var block = document.querySelector('.wls-list-block-root');
      if (!block) return false;
      if (!SN.claim(block, 'wlsHeroCopy')) return true;
      apply(block);
      new MutationObserver(function () { apply(block); })
        .observe(block, { childList: true, subtree: true, characterData: true });
      return true;
    }

    if (attach()) return;
    var wait = new MutationObserver(function () { if (attach()) wait.disconnect(); });
    wait.observe(document.body, { childList: true, subtree: true });
  });


  /* --- wishlist page: add-to-cart feedback (#352) -------------------------
     Two things on one signal. The app gives no state on its own button and no
     event we can subscribe to, but it DOES render `.wls-toast` when an add
     succeeds — so that element appearing is used as the success signal, and
     the click alone is never treated as success (a failed add would otherwise
     show a green confirmation for something that never entered the cart).
     The app's toast is hidden in CSS rather than blocked, precisely so it can
     keep firing this signal.
     The button flash reuses buyButtonFlashAdded() — the same helper, class and
     timing the PDP and product cards already use — so the confirmation is the
     one shoppers have seen elsewhere on the site.
     Product image and title are read from the CARD that was clicked, not from
     the app's toast, so our copy does not depend on its markup surviving. */
  SN.register('wlsCartFeedback', function () {
    /* #375 — RETIRED. This watched for the app's own .wls-toast as its success
       signal, which only worked while the app performed the add. wlsAtc now
       intercepts the click on both pages, so that toast never appears and this
       could only misfire: its `pending` is still set by the capture listener it
       registered first, so an unrelated .wls-toast (a wishlist add/remove, say)
       would have flashed the cart button and raised a cart toast for an action
       that was not an add. Left in place rather than deleted so the mechanism
       stays documented if the interception is ever reverted. */
    return;
    /* #371 — also runs on the SHARED list (/apps/wlsp/shared), which was
       reported with no green flash and no toast. Nothing else had to change:
       the shared page renders the same .wls-card / .wls-atc-btn markup and the
       app fires the same .wls-toast success signal, so widening the gate is the
       whole fix. Its button carries an extra .wls-dynamic-atc-btn class and sits
       inside a <form>, neither of which this module looks at. */
    if (location.pathname.indexOf('wishlistsuite-wishlist') === -1 &&
        location.pathname.indexOf('/apps/wlsp/') === -1) return;
    if (SN._wlsCartFeedback) return;
    SN._wlsCartFeedback = true;

    var pending = null;

    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest && e.target.closest('.wls-atc-btn');
      if (btn) pending = btn;
    }, true);

    function showToast(card) {
      /* #354 — the toast itself now lives in snShowToast() below, shared with
         the wishlist add/remove feedback. This wrapper only maps a CARD onto
         that helper's options. */
      var img = card && card.querySelector('.wls-card-img');
      var name = card && card.querySelector('.wls-card-title');
      snShowToast({
        img: img && (img.currentSrc || img.getAttribute('src')),
        name: name && name.textContent.trim(),
        status: 'Toegevoegd aan winkelwagen',
        cta: 'Ga naar winkelwagen',
        href: '/cart'
      });
    }

    function onSuccess() {
      var btn = pending;
      pending = null;
      if (!btn) return;
      buyButtonFlashAdded(btn, false);
      showToast(btn.closest('.wls-card'));
    }

    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var k = 0; k < added.length; k++) {
          var n = added[k];
          if (n.nodeType === 1 && n.classList && n.classList.contains('wls-toast')) {
            onSuccess();
            return;
          }
        }
      }
    }).observe(document.body, { childList: true });
  });


  /* --- shared toast + wishlist add/remove feedback (#354) -----------------
     ONE toast component, three situations: added to cart (#352), added to the
     wishlist, removed from the wishlist. A single element is reused rather than
     built per event so a rapid second action replaces the first instead of
     stacking boxes up the screen.

     Every part is optional. The image, the title line, the status line and the
     CTA each hide themselves when not supplied, which is what lets the remove
     case be just an image and a word without a second layout.

     The href is REMOVED, not blanked, when there is nowhere to go: an <a> with
     no href is inert — not focusable, no navigation, no pointer cursor — so the
     remove toast cannot be clicked into a dead end, while the add-to-cart and
     "Weergave" toasts stay fully clickable (#353). */
  var snToastEl = null;
  var snToastTimer = null;
  /* #356 — scroll dismissal state. Baseline is stamped when the toast is SHOWN
     (not on the first scroll frame), for the reason #347 established on the card
     menu: an instant or momentum-free scroll can deliver a single event, and a
     first-frame baseline spends that event recording instead of acting. The
     400ms + 20px guard stops the toast being dismissed by the tail of the same
     gesture that triggered it — a tap after a flick still carries momentum. */
  var snToastShownY = 0;
  var snToastShownT = 0;
  var snToastScrollBound = false;

  function snBindToastScroll() {
    if (snToastScrollBound) return;
    snToastScrollBound = true;
    window.addEventListener('scroll', function () {
      if (!snToastEl || !snToastEl.classList.contains('sn-in')) return;
      if (Date.now() - snToastShownT < 400) return;
      if (Math.abs(window.pageYOffset - snToastShownY) < 20) return;
      clearTimeout(snToastTimer);
      snToastEl.classList.remove('sn-in');
    }, { passive: true });
  }

  function snShowToast(o) {
    if (!snToastEl) {
      snToastEl = document.createElement('a');
      snToastEl.className = 'sn-wl-toast';
      snToastEl.innerHTML =
        '<img alt="" />' +
        '<div class="sn-wl-toast-info">' +
          '<div class="sn-wl-toast-name"></div>' +
          '<div class="sn-wl-toast-status"></div>' +
        '</div>' +
        '<span class="sn-wl-toast-cta"></span>';
      document.body.appendChild(snToastEl);
    }

    var im = snToastEl.querySelector('img');
    if (o.img) { im.src = o.img; im.style.display = ''; }
    else { im.removeAttribute('src'); im.style.display = 'none'; }

    var nameEl = snToastEl.querySelector('.sn-wl-toast-name');
    nameEl.textContent = o.name || '';
    nameEl.style.display = o.name ? '' : 'none';

    var statusEl = snToastEl.querySelector('.sn-wl-toast-status');
    statusEl.textContent = o.status || '';
    statusEl.style.display = o.status ? '' : 'none';

    var ctaEl = snToastEl.querySelector('.sn-wl-toast-cta');
    ctaEl.textContent = o.cta || '';
    ctaEl.style.display = o.cta ? '' : 'none';

    if (o.href) snToastEl.setAttribute('href', o.href);
    else snToastEl.removeAttribute('href');

    void snToastEl.offsetWidth;
    snToastEl.classList.add('sn-in');

    snToastShownY = window.pageYOffset;
    snToastShownT = Date.now();
    snBindToastScroll();

    clearTimeout(snToastTimer);
    snToastTimer = setTimeout(function () {
      if (snToastEl) snToastEl.classList.remove('sn-in');
    }, 3000); /* #356 — 5000 -> 3000ms, all toasts (supersedes #353's 5s) */
  }

  /* Wishlist add/remove. Runs site-wide, not just on the wishlist page: hearts
     live on the PDP, on every product card, and inside the wishlist itself.

     Success signal is the app's own `.wishlist-toast` appearing — the same
     reasoning as #352: the click alone would confirm actions that failed. That
     element is hidden in CSS, never blocked, so it can keep firing the signal.

     ADDED vs REMOVED is read from the heart's `data-wishlisted` / `aria-pressed`
     AFTER the app has updated it, not from the toast's wording — the app's copy
     is localised and would break the moment the shop language changed, whereas
     those attributes are structural.

     Removals from the card menu have no heart to read, so the card whose menu
     was opened is remembered when that menu is tapped and used instead. */
  SN.register('wlsWishlistFeedback', function () {
    if (SN._wlsWishFeedback) return;
    SN._wlsWishFeedback = true;

    var WISHLIST_URL = '/pages/wishlistsuite-wishlist';
    var pendingHeart = null;
    var lastMenuCard = null;
    var pendingRemoveCard = null;

    function productInfo(el) {
      var card = el.closest('.legacy-product-card') || el.closest('.wls-card');
      var img, title;
      if (card) {
        img = card.querySelector('img');
        title = card.querySelector('.sn-card-title, .wls-card-title');
      } else {
        var mp = document.querySelector('#main-product');
        if (mp) {
          img = mp.querySelector('ul.l4pr img');
          title = mp.querySelector('header h1, header h2, header h3, header h4');
        }
      }
      return {
        img: img && (img.currentSrc || img.getAttribute('src')),
        title: title && title.textContent.trim()
      };
    }

    /* #355 — WINDOW, not document. The app installs its own capture-phase click
       delegation on `document` for hearts and calls stopImmediatePropagation()
       in it, which skips every capture listener registered on document AFTER
       its own — ours included, so this handler never ran and no toast appeared.
       Proved by injecting an identical probe listener on document: it did not
       fire either, while the heart itself worked normally.
       Capture order is window -> document -> ... , so listening on window runs
       BEFORE the app can stop the event, without interfering with its handling
       (we only observe; we never stop or cancel anything). */
    window.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var heart = t.closest('.product-card-wishlist-btn, .wls-product-page-image-icon');
      if (heart) { pendingHeart = heart; pendingRemoveCard = null; return; }
      var menuBtn = t.closest('.wls-item-menu-btn');
      if (menuBtn) { lastMenuCard = menuBtn.closest('.wls-card'); return; }
      if (t.closest('#wls-popup-remove-btn')) {
        pendingHeart = null;
        pendingRemoveCard = lastMenuCard;
      }
    }, true);

    function onWishToast() {
      if (pendingRemoveCard) {
        var ri = productInfo(pendingRemoveCard);
        pendingRemoveCard = null;
        snShowToast({ img: ri.img, name: 'Artikel verwijderd' });
        return;
      }
      var btn = pendingHeart;
      pendingHeart = null;
      if (!btn) return;
      var added = btn.getAttribute('data-wishlisted') === 'true' ||
                  btn.getAttribute('aria-pressed') === 'true';
      var info = productInfo(btn);
      if (added) {
        snShowToast({ img: info.img, name: info.title, cta: 'Weergave', href: WISHLIST_URL });
      } else {
        snShowToast({ img: info.img, name: 'Artikel verwijderd' });
      }
    }

    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var k = 0; k < added.length; k++) {
          var n = added[k];
          if (n.nodeType === 1 && n.classList && n.classList.contains('wishlist-toast')) {
            setTimeout(onWishToast, 60);
            return;
          }
        }
      }
    }).observe(document.body, { childList: true });
  });


  /* --- shared wishlist page: Dutch copy (#367) ----------------------------
     The shared view ships English strings ("Shared Wishlist", "Someone shared
     their favorite picks with you!", "Add to Cart") on a Dutch storefront —
     and "Add to Cart" is the SAME button that reads "In winkelwagen" one page
     over, so the inconsistency is visible to any shopper who follows a share
     link. Translated here for the same reason the hero copy is (#348): the
     text is app-rendered, so there is no template to change.
     The heading keeps its child element (the count chip) by writing only its
     leading TEXT NODE — replacing textContent would delete that span.
     The item-count line is rebuilt from the number already in it, so it stays
     correct as the list changes, and singular/plural are handled. */
  /* #375 — ADD TO CART for the wishlist AND shared lists, with a real stock cap.

     Why we own the click on BOTH pages now (it was the shared page only): the
     reported "keeps adding more than the stock" is real, and it is NOT a display
     bug. Measured against a variant with inventoryPolicy DENY, tracked inventory
     and quantity 2, stocked at one active location that fulfils online orders:
     POST /cart/add.js with quantity 9999 returned HTTP 200, and /cart.js then
     reported item_count 9999. Repeated single adds walked 1,2,3,4,5 straight past
     2. Shopify is not enforcing the policy at add time here, so there is no error
     response to react to — the cap has to be computed BEFORE adding.

     Stock comes from sections/shopnest-stock.liquid, because nothing on the
     storefront exposes a quantity to JS: /products/<handle>.js carries only
     `available`, a boolean. Liquid does expose variant.inventory_quantity, so
     that section republishes it; fetched once per handle and cached.

     Only variants that are BOTH managed and policy 'deny' are capped. A variant
     set to keep selling when out of stock is MEANT to oversell, and this must not
     quietly override that decision.

     The cart bubble is refreshed from /cart.js after every add, on both pages,
     since nothing else updates it now that the app's handler is out of the path.
     Worth noting the badge was never wrong: it counts the whole cart, so 39
     against a stock of 2 was 39 real items — the adds were the bug, not the count. */
  var wlsStockCache = {};

  function wlsGetStock(handle) {
    if (!handle) return Promise.resolve(null);
    if (wlsStockCache[handle]) return wlsStockCache[handle];
    wlsStockCache[handle] = fetch('/products/' + handle + '?section_id=shopnest-stock')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var d = document.createElement('div');
        d.innerHTML = html;
        var s = d.querySelector('script[data-sn-stock]');
        return s ? JSON.parse(s.textContent) : null;
      })
      .catch(function () { return null; });
    return wlsStockCache[handle];
  }

  function wlsSyncCartCount() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var el = document.getElementById('cart-count');
        if (el && cart) el.textContent = cart.item_count;
        return cart;
      })
      .catch(function () { return null; });
  }

  /* Deliberately no regex in this href parsing: the literal-dot and escaped-slash
     forms do not survive this file's edit pipeline (three separate breakages this
     session), so indexOf/split is used, which needs no escaping at all. */
  function wlsHrefIn(card, needle) {
    if (!card) return null;
    var as = card.querySelectorAll('a');
    for (var i = 0; i < as.length; i++) {
      var h = as[i].getAttribute('href') || '';
      if (h.indexOf(needle) > -1) return h;
    }
    return null;
  }

  function wlsVariantOf(btn, card) {
    var form = btn.closest('form');
    if (form) {
      var inp = form.querySelector('input[name="id"]');
      if (inp && inp.value) return String(inp.value);
    }
    var h = wlsHrefIn(card, 'variant=');
    if (!h) return null;
    return h.split('variant=')[1].split('&')[0].split('#')[0];
  }

  function wlsHandleOf(card) {
    var h = wlsHrefIn(card, '/products/');
    if (!h) return null;
    return h.split('/products/')[1].split('?')[0].split('#')[0];
  }

  function wlsFlashMax(btn) {
    if (btn.dataset.snBusy) return;
    btn.dataset.snBusy = '1';
    var original = btn.innerHTML;
    btn.classList.add('sn-wls-max');
    btn.textContent = 'Max. aantal bereikt';
    setTimeout(function () {
      btn.innerHTML = original;
      btn.classList.remove('sn-wls-max');
      delete btn.dataset.snBusy;
    }, 1800);
  }

  SN.register('wlsAtc', function () {
    if (location.pathname.indexOf('wishlistsuite-wishlist') === -1 &&
        location.pathname.indexOf('/apps/wlsp/') === -1) return;
    if (SN._wlsAtc) return;
    SN._wlsAtc = true;

    /* Capture + stopImmediatePropagation: on the wishlist page the button carries
       an inline onclick="WLS.addToCart(...)", and on the shared page the app calls
       form.submit(), which fires no submit event (the #373 finding). A capture
       listener that stops the event dead is the only thing that takes both out of
       the path. */
    /* #376 — the POINTER events are stopped too, not just the click. Reported as
       "sometimes the whole product card becomes clickable" when aiming for the
       cart button. Hit-testing the button proved it is the topmost element at its
       centre and at both corners, so nothing is covering it — which leaves a
       handler that fires EARLIER than click. The app binds card navigation at the
       pointer level, so on a tap that lands on the button the card's handler had
       already run by the time our click listener could stop it; on a mouse click
       the ordering happens to work out, which is why it was intermittent.
       Stopping propagation at pointerdown/touchstart/mousedown closes that window.
       preventDefault is deliberately NOT called here — only propagation is stopped
       — so the button still receives focus and still generates its click, which is
       what the handler below acts on. */
    ['pointerdown', 'touchstart', 'mousedown'].forEach(function (evt) {
      document.addEventListener(evt, function (e) {
        var b = e.target && e.target.closest && e.target.closest('.wls-atc-btn');
        if (b) e.stopPropagation();
      }, true);
    });

    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest && e.target.closest('.wls-atc-btn');
      if (!btn) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      if (btn.dataset.snBusy) return;

      var card = btn.closest('.wls-card');
      var vid = wlsVariantOf(btn, card);
      var handle = wlsHandleOf(card);
      if (!vid) return;

      Promise.all([
        wlsGetStock(handle),
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .catch(function () { return null; })
      ]).then(function (both) {
        var stock = both[0], cart = both[1];
        var v = null;
        if (stock && stock.variants) {
          for (var i = 0; i < stock.variants.length; i++) {
            if (String(stock.variants[i].id) === String(vid)) { v = stock.variants[i]; break; }
          }
        }
        var inCart = 0;
        if (cart && cart.items) {
          for (var k = 0; k < cart.items.length; k++) {
            if (String(cart.items[k].variant_id) === String(vid)) inCart += cart.items[k].quantity;
          }
        }
        if (v && v.managed && v.policy === 'deny' && inCart + 1 > v.qty) {
          wlsFlashMax(btn);
          return null;
        }
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: vid, quantity: 1 })
        }).then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        });
      }).then(function (added) {
        if (!added) return;
        buyButtonFlashAdded(btn, false);
        var img = card && card.querySelector('.wls-card-img');
        var name = card && card.querySelector('.wls-card-title');
        snShowToast({
          img: img && (img.currentSrc || img.getAttribute('src')),
          name: name && name.textContent.trim(),
          status: 'Toegevoegd aan winkelwagen',
          cta: 'Ga naar winkelwagen',
          href: '/cart'
        });
        return wlsSyncCartCount();
      }).catch(function () {});
    }, true);
  });

  /* #380 — the copy-link button had no feedback at all: it copies, but nothing
     on screen changes, so there is no way to tell it worked. The app gives us a
     real hook — the control is a <button class="wls-share-icon-btn"> whose inline
     onclick calls WLS.copyLink(...) — so this listens rather than reimplementing
     the copy: the app still owns the clipboard write, and this only reports it.
     Propagation is deliberately NOT stopped for that reason.
     Delegated on document so it survives the app re-rendering its block, and
     registered once via the SN flag rather than per-render. Reuses the same
     toast component as the cart and wishlist feedback (#354) with only a status
     line — no image, no CTA — which that helper already supports. */
  SN.register('wlsCopyLinkToast', function () {
    if (!/wishlistsuite-wishlist|\/apps\/wlsp\//.test(location.pathname)) return;
    if (SN._wlsCopyToast) return;
    SN._wlsCopyToast = true;

    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest && e.target.closest('.wls-share-icon-btn');
      if (!btn || btn.tagName !== 'BUTTON') return;
      /* Identify the copy control by its own onclick, not by position in the row:
         it is the only share control that is a <button> (the other four are links),
         but the onclick check keeps this correct if the app ever adds another. */
      if ((btn.getAttribute('onclick') || '').indexOf('copyLink') === -1) return;
      snShowToast({ status: 'Link gekopieerd' });
      /* CAPTURE phase (#381). The bubble-phase version never fired: the app's own
         copyLink handler stops propagation, so the event never reached document.
         Capture runs before the target's inline onclick, which also means this
         reports the intent to copy rather than a confirmed copy — acceptable here,
         since the app owns the clipboard write and the failure mode (clipboard
         blocked) is rare and already silent. Propagation is still not stopped. */
    }, true);
  });

  SN.register('wlsSharedCopy', function () {
    if (location.pathname.indexOf('/apps/wlsp/') === -1) return;
    /* #374 — page marker, so CSS can target the shared list without touching the
       wishlist page (both render .wls-page-wrapper). */
    document.documentElement.classList.add('sn-wls-shared');

    function apply(block) {
      /* #382 - the title rendered TWICE. The app emits its own
         <span class="wls-heading-text">, already in Dutch, and the code here was
         ALSO writing the title into the heading's leading text node - which in the
         current app markup is nothing but the whitespace between two tags. Result:
         "Gedeelde verlanglijst Gedeelde verlanglijst", confirmed by dumping the
         heading's child nodes live.
         Now the span is the target when it exists, and any non-blank text node we
         previously left in the heading is blanked back to a single space (the
         separator the app itself puts between the title and the count chip). The
         old text-node path stays as the fallback for the app build that had no
         span, so this is correct either way. Idempotent by construction - both
         branches no-op once the text already matches, which matters because the
         MutationObserver below re-runs this on every app re-render. */
      var h = block.querySelector('.wls-heading');
      if (h) {
        var hSpan = h.querySelector('.wls-heading-text');
        if (hSpan) {
          if (hSpan.textContent.trim() !== 'Gedeelde verlanglijst') {
            hSpan.textContent = 'Gedeelde verlanglijst';
          }
          for (var hi = 0; hi < h.childNodes.length; hi++) {
            var hn = h.childNodes[hi];
            if (hn.nodeType === 3 && hn.nodeValue.trim()) hn.nodeValue = ' ';
          }
        } else if (h.firstChild && h.firstChild.nodeType === 3 &&
            h.firstChild.nodeValue.indexOf('Gedeelde') === -1) {
          h.firstChild.nodeValue = 'Gedeelde verlanglijst ';
        }
      }

      /* #383 - the shared page's empty-state button points at /collections/all,
         the app's default. My Wishlist's equivalent was pointed at /collections
         (Alle categorieen) in #357; same button, same destination. Guarded on the
         current value so the observer above does not see an attribute change it
         caused itself. */
      var emptyBtn = block.querySelector('.wls-empty-btn');
      if (emptyBtn && emptyBtn.getAttribute('href') !== '/collections') {
        emptyBtn.setAttribute('href', '/collections');
      }

      var sub = block.querySelector('.wls-subheading');
      var subText = 'Iemand deelt zijn favorieten met je';
      if (sub && sub.textContent.trim() !== subText) sub.textContent = subText;

      var label = block.querySelector('.wls-share-label');
      if (label) {
        var n = (label.textContent.match(/\d+/) || [])[0];
        if (n) {
          var want = n + (n === '1' ? ' artikel' : ' artikelen') + ' in deze verlanglijst';
          if (label.textContent.trim() !== want) label.textContent = want;
        }
      }

      var atc = block.querySelectorAll('.wls-atc-text');
      for (var i = 0; i < atc.length; i++) {
        if (atc[i].textContent.trim() !== 'In winkelwagen') atc[i].textContent = 'In winkelwagen';
      }

      /* #371 — "Bespaar %" line, which the shared page's card markup simply does
         not include: the wishlist page gets .wls-save-amount from the app, while
         the shared renderer emits title + price only. Rebuilt here from the two
         prices already on the card, reusing the SAME class so every existing rule
         for it — 12px, the theme green, the 2px gap above the price — applies with
         no new CSS at all.
         Parsing is Dutch-format aware ("25,49" -> 25.49); a card with no compare
         price, or one not larger, simply gets no line — same as a non-discounted
         product on the wishlist page. Idempotent by construction: it returns early
         when the element exists, so the observer that re-runs this on every app
         re-render cannot stack duplicates. */
      var cards = block.querySelectorAll('.wls-card');
      for (var c = 0; c < cards.length; c++) {
        var card = cards[c];
        if (card.querySelector('.wls-save-amount')) continue;
        var priceEl = card.querySelector('.wls-price');
        var compEl = card.querySelector('.wls-compare-price');
        if (!priceEl || !compEl) continue;
        var num = function (el) {
          /* split/join rather than a regex: the literal-dot escape does not
             survive this file's edit pipeline, and /./g (any char) silently
             wiped the whole string -> parseFloat('') -> NaN -> every card
             skipped. That is why the line never appeared. */
          var t = (el.textContent || '').replace(/[^0-9,.]/g, '').split('.').join('').replace(',', '.');
          return parseFloat(t);
        };
        var now = num(priceEl), was = num(compEl);
        if (!(was > now) || !isFinite(was) || !isFinite(now)) continue;
        var pct = Math.round((was - now) / was * 100);
        if (!pct) continue;
        var p = document.createElement('p');
        p.className = 'wls-save-amount';
        p.textContent = 'Bespaar ' + pct + '%';
        var host = priceEl.parentNode;
        if (host && host.parentNode) host.parentNode.insertBefore(p, host.nextSibling);
      }

      /* #375 — the reveal now waits for the CARDS, not just the header. #374
         signalled ready as soon as the heading was translated, but the app
         renders the grid separately and a beat later, so the English card copy
         ("Add to Cart", no Bespaar line) was still on screen — which is what was
         reported as "still shows the old shared page". Ready now means every
         .wls-atc-text has been translated; with no cards at all it is trivially
         true, so an empty list is not held back. The 400ms bounded reveal in CSS
         is unchanged and still the safety net. */
      var atcAll = block.querySelectorAll('.wls-atc-text');
      var ready = true;
      for (var t2 = 0; t2 < atcAll.length; t2++) {
        if (atcAll[t2].textContent.trim() !== 'In winkelwagen') { ready = false; break; }
      }
      if (ready) document.documentElement.classList.add('sn-wls-copy-ready');
    }

    function attach() {
      var block = document.querySelector('.wls-page-wrapper');
      if (!block) return false;
      if (!SN.claim(block, 'wlsSharedCopy')) return true;
      apply(block);
      new MutationObserver(function () { apply(block); })
        .observe(block, { childList: true, subtree: true, characterData: true });
      return true;
    }

    if (attach()) return;
    var wait = new MutationObserver(function () { if (attach()) wait.disconnect(); });
    wait.observe(document.body, { childList: true, subtree: true });
  });

})();

